import _regeneratorRuntime from "/var/www/vhosts/koelewijn-crookewit.nl/gatsby/koelewijn-crookewit.nl/node_modules/@babel/runtime/regenerator/index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/esnext.global-this.js";
import e, { useReducer as t, useContext as n, useRef as o, useState as r, useEffect as i, Children as a, isValidElement as s, cloneElement as c, createContext as l, createElement as u, Fragment as d, forwardRef as p, Component as h, useCallback as f } from "react";
import m from "prop-types";
import v from "react-dom";
function g(e) {
  return (g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}
function b(e, t, n, o, r, i, a) {
  try {
    var s = e[i](a),
      c = s.value;
  } catch (e) {
    return void n(e);
  }
  s.done ? t(c) : Promise.resolve(c).then(o, r);
}
function y(e) {
  return function () {
    var t = this,
      n = arguments;
    return new Promise(function (o, r) {
      var i = e.apply(t, n);
      function a(e) {
        b(i, o, r, a, s, "next", e);
      }
      function s(e) {
        b(i, o, r, a, s, "throw", e);
      }
      a(void 0);
    });
  };
}
function w(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function x() {
  return (x = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }).apply(this, arguments);
}
function E(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function S(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? E(Object(n), !0).forEach(function (t) {
      w(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : E(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function C(e, t) {
  if (e !== t) throw new TypeError("Cannot instantiate an arrow function");
}
function k(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function L(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
    var n = [],
      o = !0,
      r = !1,
      i = void 0;
    try {
      for (var a, s = e[Symbol.iterator](); !(o = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); o = !0);
    } catch (e) {
      r = !0, i = e;
    } finally {
      try {
        o || null == s.return || s.return();
      } finally {
        if (r) throw i;
      }
    }
    return n;
  }(e, t) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return T(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === n && e.constructor && (n = e.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(n);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return T(e, t);
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function T(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++) o[n] = e[n];
  return o;
}
var O = {
    elements: [],
    isOpened: !1,
    options: {
      buttons: {
        backgroundColor: "rgba(30,30,36,0.8)",
        iconColor: "rgba(255, 255, 255, 0.8)",
        iconPadding: "5px",
        showAutoplayButton: !0,
        showCloseButton: !0,
        showDownloadButton: !0,
        showFullscreenButton: !0,
        showNextButton: !0,
        showPrevButton: !0,
        size: "40px"
      },
      settings: {
        autoplaySpeed: 3e3,
        disableKeyboardControls: !1,
        disableWheelControls: !1,
        disablePanzoom: !1,
        hideControlsAfter: 3e3,
        lightboxTransitionSpeed: 600,
        lightboxTransitionTimingFunction: "ease",
        overlayColor: "rgba(0, 0, 0, 0.9)",
        slideTransitionSpeed: 600,
        slideTransitionTimingFunction: "ease"
      },
      caption: {
        showCaption: !0,
        captionColor: "#FFFFFF",
        captionFontFamily: "inherit",
        captionFontSize: "inherit",
        captionFontStyle: "inherit",
        captionFontWeight: "inherit",
        captionTextTransform: "inherit"
      },
      thumbnails: {
        showThumbnails: !0,
        thumbnailsOpacity: .4,
        thumbnailsSize: ["100px", "80px"]
      }
    },
    selectedElement: {
      caption: "",
      height: 0,
      id: "",
      source: "",
      thumbnail: "",
      width: ""
    },
    callbacks: {
      onCountSlides: function () {
        C(this, void 0);
      }.bind(void 0),
      onSlideChange: function () {
        C(this, void 0);
      }.bind(void 0),
      onLightboxClosed: function () {
        C(this, void 0);
      }.bind(void 0),
      onLightboxOpened: function () {
        C(this, void 0);
      }.bind(void 0)
    }
  },
  N = e.createContext(O),
  A = function (n) {
    var o = this;
    C(this, void 0);
    var r = function (e, t) {
        switch (C(this, o), t.type) {
          case "GRAB_SETTINGS":
            return S({}, e, {}, t.mergedSettings);
          case "GRAB_ELEMENTS":
            return S({}, e, {
              elements: t.elements
            });
          case "HANDLE_ELEMENT":
            return S({}, e, {
              isOpened: !0,
              selectedElement: S({}, t.element)
            });
          case "OPEN_AT_INDEX":
            return S({}, e, {
              isOpened: !0,
              selectedElement: S({}, e.elements[t.index])
            });
          case "CLOSE_LIGHTBOX":
            return S({}, e, {
              isOpened: !1
            });
          default:
            return e;
        }
      }.bind(this),
      i = L(t(r, O), 2),
      a = i[0],
      s = i[1];
    return e.createElement(N.Provider, {
      value: S({}, a, {
        dispatch: s
      })
    }, n.children);
  }.bind(void 0);
A.propTypes = {
  children: m.oneOfType([m.arrayOf(m.node), m.node]).isRequired
};
var _ = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function P(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}
var R = P(function (e) {
    !function (t, n) {
      e.exports ? e.exports = n() : t.EvEmitter = n();
    }("undefined" != typeof window ? window : _, function () {
      function e() {}
      var t = e.prototype;
      return t.on = function (e, t) {
        if (e && t) {
          var n = this._events = this._events || {},
            o = n[e] = n[e] || [];
          return -1 == o.indexOf(t) && o.push(t), this;
        }
      }, t.once = function (e, t) {
        if (e && t) {
          this.on(e, t);
          var n = this._onceEvents = this._onceEvents || {};
          return (n[e] = n[e] || {})[t] = !0, this;
        }
      }, t.off = function (e, t) {
        var n = this._events && this._events[e];
        if (n && n.length) {
          var o = n.indexOf(t);
          return -1 != o && n.splice(o, 1), this;
        }
      }, t.emitEvent = function (e, t) {
        var n = this._events && this._events[e];
        if (n && n.length) {
          n = n.slice(0), t = t || [];
          for (var o = this._onceEvents && this._onceEvents[e], r = 0; r < n.length; r++) {
            var i = n[r];
            o && o[i] && (this.off(e, i), delete o[i]), i.apply(this, t);
          }
          return this;
        }
      }, t.allOff = function () {
        delete this._events, delete this._onceEvents;
      }, e;
    });
  }),
  z = P(function (e) {
    /*!
     * imagesLoaded v4.1.4
     * JavaScript is all like "You images are done yet or what?"
     * MIT License
     */
    !function (t, n) {
      e.exports ? e.exports = n(t, R) : t.imagesLoaded = n(t, t.EvEmitter);
    }("undefined" != typeof window ? window : _, function (e, t) {
      var n = e.jQuery,
        o = e.console;
      function r(e, t) {
        for (var n in t) e[n] = t[n];
        return e;
      }
      var i = Array.prototype.slice;
      function a(e, t, s) {
        if (!(this instanceof a)) return new a(e, t, s);
        var c,
          l = e;
        ("string" == typeof e && (l = document.querySelectorAll(e)), l) ? (this.elements = (c = l, Array.isArray(c) ? c : "object" == typeof c && "number" == typeof c.length ? i.call(c) : [c]), this.options = r({}, this.options), "function" == typeof t ? s = t : r(this.options, t), s && this.on("always", s), this.getImages(), n && (this.jqDeferred = new n.Deferred()), setTimeout(this.check.bind(this))) : o.error("Bad element for imagesLoaded " + (l || e));
      }
      a.prototype = Object.create(t.prototype), a.prototype.options = {}, a.prototype.getImages = function () {
        this.images = [], this.elements.forEach(this.addElementImages, this);
      }, a.prototype.addElementImages = function (e) {
        "IMG" == e.nodeName && this.addImage(e), !0 === this.options.background && this.addElementBackgroundImages(e);
        var t = e.nodeType;
        if (t && s[t]) {
          for (var n = e.querySelectorAll("img"), o = 0; o < n.length; o++) {
            var r = n[o];
            this.addImage(r);
          }
          if ("string" == typeof this.options.background) {
            var i = e.querySelectorAll(this.options.background);
            for (o = 0; o < i.length; o++) {
              var a = i[o];
              this.addElementBackgroundImages(a);
            }
          }
        }
      };
      var s = {
        1: !0,
        9: !0,
        11: !0
      };
      function c(e) {
        this.img = e;
      }
      function l(e, t) {
        this.url = e, this.element = t, this.img = new Image();
      }
      return a.prototype.addElementBackgroundImages = function (e) {
        var t = getComputedStyle(e);
        if (t) for (var n = /url\((['"])?(.*?)\1\)/gi, o = n.exec(t.backgroundImage); null !== o;) {
          var r = o && o[2];
          r && this.addBackground(r, e), o = n.exec(t.backgroundImage);
        }
      }, a.prototype.addImage = function (e) {
        var t = new c(e);
        this.images.push(t);
      }, a.prototype.addBackground = function (e, t) {
        var n = new l(e, t);
        this.images.push(n);
      }, a.prototype.check = function () {
        var e = this;
        function t(t, n, o) {
          setTimeout(function () {
            e.progress(t, n, o);
          });
        }
        this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? this.images.forEach(function (e) {
          e.once("progress", t), e.check();
        }) : this.complete();
      }, a.prototype.progress = function (e, t, n) {
        this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded, this.emitEvent("progress", [this, e, t]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, e), this.progressedCount == this.images.length && this.complete(), this.options.debug && o && o.log("progress: " + n, e, t);
      }, a.prototype.complete = function () {
        var e = this.hasAnyBroken ? "fail" : "done";
        if (this.isComplete = !0, this.emitEvent(e, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
          var t = this.hasAnyBroken ? "reject" : "resolve";
          this.jqDeferred[t](this);
        }
      }, c.prototype = Object.create(t.prototype), c.prototype.check = function () {
        this.getIsImageComplete() ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image(), this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.proxyImage.src = this.img.src);
      }, c.prototype.getIsImageComplete = function () {
        return this.img.complete && this.img.naturalWidth;
      }, c.prototype.confirm = function (e, t) {
        this.isLoaded = e, this.emitEvent("progress", [this, this.img, t]);
      }, c.prototype.handleEvent = function (e) {
        var t = "on" + e.type;
        this[t] && this[t](e);
      }, c.prototype.onload = function () {
        this.confirm(!0, "onload"), this.unbindEvents();
      }, c.prototype.onerror = function () {
        this.confirm(!1, "onerror"), this.unbindEvents();
      }, c.prototype.unbindEvents = function () {
        this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
      }, l.prototype = Object.create(c.prototype), l.prototype.check = function () {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url, this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
      }, l.prototype.unbindEvents = function () {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
      }, l.prototype.confirm = function (e, t) {
        this.isLoaded = e, this.emitEvent("progress", [this, this.element, t]);
      }, a.makeJQueryPlugin = function (t) {
        (t = t || e.jQuery) && ((n = t).fn.imagesLoaded = function (e, t) {
          return new a(this, e, t).jqDeferred.promise(n(this));
        });
      }, a.makeJQueryPlugin(), a;
    });
  }),
  F = require("lodash/isEqual"),
  I = require("lodash/isEmpty"),
  B = function (t) {
    var a = this;
    C(this, void 0);
    var s = t.options,
      c = t.callbacks,
      l = t.children,
      u = t.defaultOptions,
      d = t.defaultCallbacks,
      p = n(N),
      h = o(null),
      f = o(),
      m = L(r(!1), 2),
      v = m[0],
      g = m[1],
      b = L(r(!1), 2),
      y = b[0],
      w = b[1];
    return i(function () {
      var e = this;
      function t(e) {
        var t = this;
        if (w(!0), !y) return function (e) {
          F(e, p.elements) || p.dispatch({
            type: "GRAB_ELEMENTS",
            elements: e
          });
        }(e.filter(function (e) {
          return C(this, t), void 0 !== e;
        }.bind(this))), function (e, t) {
          var n = {},
            o = {};
          n = I(e) ? S({}, u, {
            buttons: S({}, u.buttons),
            settings: S({}, u.settings),
            caption: S({}, u.caption),
            thumbnails: S({}, u.thumbnails)
          }) : S({}, u, {}, e, {
            buttons: S({}, u.buttons, {}, e.buttons),
            settings: S({}, u.settings, {}, e.settings),
            caption: S({}, u.caption, {}, e.caption),
            thumbnails: S({}, u.thumbnails, {}, e.thumbnails)
          }), o = I(t) ? S({}, d) : S({}, d, {}, t);
          var r = {
            options: S({}, n),
            callbacks: S({}, o)
          };
          F(r.options, p.options) && F(r.callbacks, p.callbacks) || p.dispatch({
            type: "GRAB_SETTINGS",
            mergedSettings: r
          });
        }(s, c);
      }
      C(this, a), f.current = new MutationObserver(function (e) {
        r(h.current);
      }), f.current.observe(h.current, {
        childList: !0,
        subtree: !0
      });
      var n = function (t) {
        C(this, e), F(t, p.selectedElement) || p.dispatch({
          type: "HANDLE_ELEMENT",
          element: t
        });
      }.bind(this);
      function o(e) {
        z(e, function (e) {
          if (e.isComplete) {
            var o = e.elements[0].nodeName;
            v || (g(!0), function (e, o) {
              var r = this;
              t(e.map(function (e, t) {
                var i = this;
                if (C(this, r), e.isLoaded) {
                  e.img.id = "element".concat(t);
                  var a = /\.(gif|jpg|jpeg|tiff|png|webp)$/i.test(e.img.currentSrc || e.img.src || e.img.href),
                    s = e.img.src.includes("base64");
                  if (e.img.offsetParent.className.includes("gatsby-image-wrapper") && s) return;
                  var c = {
                    source: "IMG" === o ? e.img.currentSrc || e.img.src || e.img.href || null : e.img.parentElement.href || null,
                    thumbnail: e.img.parentElement.href ? e.img.currentSrc || null : e.img.parentElement.href || e.img.currentSrc || null,
                    caption: e.img.alt || e.img.textContent || null,
                    id: e.img.id || null,
                    width: a ? e.img.naturalWidth || null : e.img.videoWidth || null,
                    height: a ? e.img.naturalHeight || null : e.img.videoHeight || null
                  };
                  return e.img.addEventListener("click", function (e) {
                    C(this, i), e.preventDefault(), n(c);
                  }.bind(this)), c;
                }
              }.bind(this)));
            }(e.images, o));
          }
        });
      }
      function r(e) {
        var t = e.querySelectorAll("img"),
          n = e.querySelectorAll("a[data-attribute='SRL']");
        0 !== t.length && (0 === n.length ? o(t) : n.length > 0 && (o(n), n.length !== t.length && console.warn("HEY!. You have ".concat(n.length, " links and ").concat(t.length, ' images. You likely forgot to add the ** data-attribute="SRL" ** to one of your link wrapping your image!'))));
      }
      r(h.current);
    }.bind(this), [y, p, v, d, u, s, c]), e.createElement("div", {
      ref: h
    }, l);
  }.bind(void 0);
function D() {
  return (D = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }).apply(this, arguments);
}
function j(e, t) {
  if (null == e) return {};
  var n,
    o,
    r = {},
    i = Object.keys(e);
  for (o = 0; o < i.length; o++) n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);
  return r;
}
function M(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
function q(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
B.propTypes = {
  defaultOptions: m.shape({
    settings: m.shape({
      autoplaySpeed: m.number,
      disableKeyboardControls: m.bool,
      disableWheelControls: m.bool,
      disablePanzoom: m.bool,
      hideControlsAfter: m.oneOfType([m.number, m.bool]),
      lightboxTransitionSpeed: m.number,
      lightboxTransitionTimingFunction: m.string,
      overlayColor: m.string,
      slideTransitionSpeed: m.number,
      slideTransitionTimingFunction: m.string
    }),
    buttons: m.shape({
      backgroundColor: m.string,
      iconColor: m.string,
      iconPadding: m.string,
      showAutoplayButton: m.bool,
      showCloseButton: m.bool,
      showDownloadButton: m.bool,
      showFullscreenButton: m.bool,
      showNextButton: m.bool,
      showPrevButton: m.bool,
      size: m.string
    }),
    caption: m.shape({
      showCaption: m.bool,
      captionColor: m.string,
      captionFontFamily: m.string,
      captionFontSize: m.string,
      captionFontStyle: m.string,
      captionFontWeight: m.string,
      captionTextTransform: m.string
    }),
    thumbnails: m.shape({
      showThumbnails: m.bool,
      thumbnailsOpacity: m.number,
      thumbnailsSize: m.array
    })
  }),
  defaultCallbacks: m.shape({
    onSlideChange: m.func,
    onLightboxClosed: m.func,
    onCountSlides: m.func,
    onLightboxOpened: m.func
  }),
  children: m.oneOfType([m.arrayOf(m.node), m.node]).isRequired,
  options: m.object,
  callbacks: m.object
}, B.defaultProps = {
  defaultOptions: {
    settings: {
      autoplaySpeed: 3e3,
      hideControlsAfter: 3e3,
      disableKeyboardControls: !1,
      disableWheelControls: !1,
      disablePanzoom: !1,
      lightboxTransitionSpeed: 600,
      lightboxTransitionTimingFunction: "ease",
      overlayColor: "rgba(0, 0, 0, 0.9)",
      slideTransitionSpeed: 600,
      slideTransitionTimingFunction: "ease"
    },
    buttons: {
      backgroundColor: "rgba(30,30,36,0.8)",
      iconColor: "rgba(255, 255, 255, 0.8)",
      iconPadding: "5px",
      showAutoplayButton: !0,
      showCloseButton: !0,
      showDownloadButton: !0,
      showFullscreenButton: !0,
      showNextButton: !0,
      showPrevButton: !0,
      size: "40px"
    },
    caption: {
      showCaption: !0,
      captionColor: "#FFFFFF",
      captionFontFamily: "inherit",
      captionFontSize: "inherit",
      captionFontStyle: "inherit",
      captionFontWeight: "inherit",
      captionTextTransform: "inherit"
    },
    thumbnails: {
      showThumbnails: !0,
      thumbnailsOpacity: .4,
      thumbnailsSize: ["100px", "80px"]
    }
  },
  defaultCallbacks: {
    onCountSlides: function () {
      C(this, void 0);
    }.bind(void 0),
    onSlideChange: function () {
      C(this, void 0);
    }.bind(void 0),
    onLightboxClosed: function () {
      C(this, void 0);
    }.bind(void 0),
    onLightboxOpened: function () {
      C(this, void 0);
    }.bind(void 0)
  }
};
var V = !1,
  W = "production" !== process.env.NODE_ENV ? m.oneOfType([m.number, m.shape({
    enter: m.number,
    exit: m.number,
    appear: m.number
  }).isRequired]) : null,
  U = "production" !== process.env.NODE_ENV ? m.oneOfType([m.string, m.shape({
    enter: m.string,
    exit: m.string,
    active: m.string
  }), m.shape({
    enter: m.string,
    enterDone: m.string,
    enterActive: m.string,
    exit: m.string,
    exitDone: m.string,
    exitActive: m.string
  })]) : null,
  Y = e.createContext(null),
  H = function (t) {
    function n(e, n) {
      var o;
      o = t.call(this, e, n) || this;
      var r,
        i = n && !n.isMounting ? e.enter : e.appear;
      return o.appearStatus = null, e.in ? i ? (r = "exited", o.appearStatus = "entering") : r = "entered" : r = e.unmountOnExit || e.mountOnEnter ? "unmounted" : "exited", o.state = {
        status: r
      }, o.nextCallback = null, o;
    }
    M(n, t), n.getDerivedStateFromProps = function (e, t) {
      return e.in && "unmounted" === t.status ? {
        status: "exited"
      } : null;
    };
    var o = n.prototype;
    return o.componentDidMount = function () {
      this.updateStatus(!0, this.appearStatus);
    }, o.componentDidUpdate = function (e) {
      var t = null;
      if (e !== this.props) {
        var n = this.state.status;
        this.props.in ? "entering" !== n && "entered" !== n && (t = "entering") : "entering" !== n && "entered" !== n || (t = "exiting");
      }
      this.updateStatus(!1, t);
    }, o.componentWillUnmount = function () {
      this.cancelNextCallback();
    }, o.getTimeouts = function () {
      var e,
        t,
        n,
        o = this.props.timeout;
      return e = t = n = o, null != o && "number" != typeof o && (e = o.exit, t = o.enter, n = void 0 !== o.appear ? o.appear : t), {
        exit: e,
        enter: t,
        appear: n
      };
    }, o.updateStatus = function (e, t) {
      if (void 0 === e && (e = !1), null !== t) {
        this.cancelNextCallback();
        var n = v.findDOMNode(this);
        "entering" === t ? this.performEnter(n, e) : this.performExit(n);
      } else this.props.unmountOnExit && "exited" === this.state.status && this.setState({
        status: "unmounted"
      });
    }, o.performEnter = function (e, t) {
      var n = this,
        o = this.props.enter,
        r = this.context ? this.context.isMounting : t,
        i = this.getTimeouts(),
        a = r ? i.appear : i.enter;
      !t && !o || V ? this.safeSetState({
        status: "entered"
      }, function () {
        n.props.onEntered(e);
      }) : (this.props.onEnter(e, r), this.safeSetState({
        status: "entering"
      }, function () {
        n.props.onEntering(e, r), n.onTransitionEnd(e, a, function () {
          n.safeSetState({
            status: "entered"
          }, function () {
            n.props.onEntered(e, r);
          });
        });
      }));
    }, o.performExit = function (e) {
      var t = this,
        n = this.props.exit,
        o = this.getTimeouts();
      n && !V ? (this.props.onExit(e), this.safeSetState({
        status: "exiting"
      }, function () {
        t.props.onExiting(e), t.onTransitionEnd(e, o.exit, function () {
          t.safeSetState({
            status: "exited"
          }, function () {
            t.props.onExited(e);
          });
        });
      })) : this.safeSetState({
        status: "exited"
      }, function () {
        t.props.onExited(e);
      });
    }, o.cancelNextCallback = function () {
      null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null);
    }, o.safeSetState = function (e, t) {
      t = this.setNextCallback(t), this.setState(e, t);
    }, o.setNextCallback = function (e) {
      var t = this,
        n = !0;
      return this.nextCallback = function (o) {
        n && (n = !1, t.nextCallback = null, e(o));
      }, this.nextCallback.cancel = function () {
        n = !1;
      }, this.nextCallback;
    }, o.onTransitionEnd = function (e, t, n) {
      this.setNextCallback(n);
      var o = null == t && !this.props.addEndListener;
      e && !o ? (this.props.addEndListener && this.props.addEndListener(e, this.nextCallback), null != t && setTimeout(this.nextCallback, t)) : setTimeout(this.nextCallback, 0);
    }, o.render = function () {
      var t = this.state.status;
      if ("unmounted" === t) return null;
      var n = this.props,
        o = n.children,
        r = j(n, ["children"]);
      if (delete r.in, delete r.mountOnEnter, delete r.unmountOnExit, delete r.appear, delete r.enter, delete r.exit, delete r.timeout, delete r.addEndListener, delete r.onEnter, delete r.onEntering, delete r.onEntered, delete r.onExit, delete r.onExiting, delete r.onExited, "function" == typeof o) return e.createElement(Y.Provider, {
        value: null
      }, o(t, r));
      var i = e.Children.only(o);
      return e.createElement(Y.Provider, {
        value: null
      }, e.cloneElement(i, r));
    }, n;
  }(e.Component);
function G() {}
H.contextType = Y, H.propTypes = "production" !== process.env.NODE_ENV ? {
  children: m.oneOfType([m.func.isRequired, m.element.isRequired]).isRequired,
  in: m.bool,
  mountOnEnter: m.bool,
  unmountOnExit: m.bool,
  appear: m.bool,
  enter: m.bool,
  exit: m.bool,
  timeout: function timeout(e) {
    var t = W;
    e.addEndListener || (t = t.isRequired);
    for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++) o[r - 1] = arguments[r];
    return t.apply(void 0, [e].concat(o));
  },
  addEndListener: m.func,
  onEnter: m.func,
  onEntering: m.func,
  onEntered: m.func,
  onExit: m.func,
  onExiting: m.func,
  onExited: m.func
} : {}, H.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: G,
  onEntering: G,
  onEntered: G,
  onExit: G,
  onExiting: G,
  onExited: G
}, H.UNMOUNTED = 0, H.EXITED = 1, H.ENTERING = 2, H.ENTERED = 3, H.EXITING = 4;
var $ = function $(e, t) {
    return e && t && t.split(" ").forEach(function (t) {
      return o = t, void ((n = e).classList ? n.classList.add(o) : function (e, t) {
        return e.classList ? !!t && e.classList.contains(t) : -1 !== (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ");
      }(n, o) || ("string" == typeof n.className ? n.className = n.className + " " + o : n.setAttribute("class", (n.className && n.className.baseVal || "") + " " + o)));
      var n, o;
    });
  },
  Z = function Z(e, t) {
    return e && t && t.split(" ").forEach(function (t) {
      return o = t, void ((n = e).classList ? n.classList.remove(o) : "string" == typeof n.className ? n.className = q(n.className, o) : n.setAttribute("class", q(n.className && n.className.baseVal || "", o)));
      var n, o;
    });
  },
  X = function (t) {
    function n() {
      for (var e, n = arguments.length, o = new Array(n), r = 0; r < n; r++) o[r] = arguments[r];
      return (e = t.call.apply(t, [this].concat(o)) || this).appliedClasses = {
        appear: {},
        enter: {},
        exit: {}
      }, e.onEnter = function (t, n) {
        e.removeClasses(t, "exit"), e.addClass(t, n ? "appear" : "enter", "base"), e.props.onEnter && e.props.onEnter(t, n);
      }, e.onEntering = function (t, n) {
        var o = n ? "appear" : "enter";
        e.addClass(t, o, "active"), e.props.onEntering && e.props.onEntering(t, n);
      }, e.onEntered = function (t, n) {
        var o = n ? "appear" : "enter";
        e.removeClasses(t, o), e.addClass(t, o, "done"), e.props.onEntered && e.props.onEntered(t, n);
      }, e.onExit = function (t) {
        e.removeClasses(t, "appear"), e.removeClasses(t, "enter"), e.addClass(t, "exit", "base"), e.props.onExit && e.props.onExit(t);
      }, e.onExiting = function (t) {
        e.addClass(t, "exit", "active"), e.props.onExiting && e.props.onExiting(t);
      }, e.onExited = function (t) {
        e.removeClasses(t, "exit"), e.addClass(t, "exit", "done"), e.props.onExited && e.props.onExited(t);
      }, e.getClassNames = function (t) {
        var n = e.props.classNames,
          o = "string" == typeof n,
          r = o ? "" + (o && n ? n + "-" : "") + t : n[t];
        return {
          baseClassName: r,
          activeClassName: o ? r + "-active" : n[t + "Active"],
          doneClassName: o ? r + "-done" : n[t + "Done"]
        };
      }, e;
    }
    M(n, t);
    var o = n.prototype;
    return o.addClass = function (e, t, n) {
      var o = this.getClassNames(t)[n + "ClassName"];
      "appear" === t && "done" === n && (o += " " + this.getClassNames("enter").doneClassName), "active" === n && e && e.scrollTop, this.appliedClasses[t][n] = o, $(e, o);
    }, o.removeClasses = function (e, t) {
      var n = this.appliedClasses[t],
        o = n.base,
        r = n.active,
        i = n.done;
      this.appliedClasses[t] = {}, o && Z(e, o), r && Z(e, r), i && Z(e, i);
    }, o.render = function () {
      var t = this.props,
        n = (t.classNames, j(t, ["classNames"]));
      return e.createElement(H, D({}, n, {
        onEnter: this.onEnter,
        onEntered: this.onEntered,
        onEntering: this.onEntering,
        onExit: this.onExit,
        onExiting: this.onExiting,
        onExited: this.onExited
      }));
    }, n;
  }(e.Component);
function K(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function J(e, t) {
  var n = Object.create(null);
  return e && a.map(e, function (e) {
    return e;
  }).forEach(function (e) {
    n[e.key] = function (e) {
      return t && s(e) ? t(e) : e;
    }(e);
  }), n;
}
function Q(e, t, n) {
  return null != n[t] ? n[t] : e.props[t];
}
function ee(e, t, n) {
  var o = J(e.children),
    r = function (e, t) {
      function n(n) {
        return n in t ? t[n] : e[n];
      }
      e = e || {}, t = t || {};
      var o,
        r = Object.create(null),
        i = [];
      for (var a in e) a in t ? i.length && (r[a] = i, i = []) : i.push(a);
      var s = {};
      for (var c in t) {
        if (r[c]) for (o = 0; o < r[c].length; o++) {
          var l = r[c][o];
          s[r[c][o]] = n(l);
        }
        s[c] = n(c);
      }
      for (o = 0; o < i.length; o++) s[i[o]] = n(i[o]);
      return s;
    }(t, o);
  return Object.keys(r).forEach(function (i) {
    var a = r[i];
    if (s(a)) {
      var l = i in t,
        u = i in o,
        d = t[i],
        p = s(d) && !d.props.in;
      !u || l && !p ? u || !l || p ? u && l && s(d) && (r[i] = c(a, {
        onExited: n.bind(null, a),
        in: d.props.in,
        exit: Q(a, "exit", e),
        enter: Q(a, "enter", e)
      })) : r[i] = c(a, {
        in: !1
      }) : r[i] = c(a, {
        onExited: n.bind(null, a),
        in: !0,
        exit: Q(a, "exit", e),
        enter: Q(a, "enter", e)
      });
    }
  }), r;
}
X.defaultProps = {
  classNames: ""
}, X.propTypes = "production" !== process.env.NODE_ENV ? D({}, H.propTypes, {
  classNames: U,
  onEnter: m.func,
  onEntering: m.func,
  onEntered: m.func,
  onExit: m.func,
  onExiting: m.func,
  onExited: m.func
}) : {};
var te = Object.values || function (e) {
    return Object.keys(e).map(function (t) {
      return e[t];
    });
  },
  ne = function (t) {
    function n(e, n) {
      var o,
        r = (o = t.call(this, e, n) || this).handleExited.bind(K(K(o)));
      return o.state = {
        contextValue: {
          isMounting: !0
        },
        handleExited: r,
        firstRender: !0
      }, o;
    }
    M(n, t);
    var o = n.prototype;
    return o.componentDidMount = function () {
      this.mounted = !0, this.setState({
        contextValue: {
          isMounting: !1
        }
      });
    }, o.componentWillUnmount = function () {
      this.mounted = !1;
    }, n.getDerivedStateFromProps = function (e, t) {
      var n,
        o,
        r = t.children,
        i = t.handleExited;
      return {
        children: t.firstRender ? (n = e, o = i, J(n.children, function (e) {
          return c(e, {
            onExited: o.bind(null, e),
            in: !0,
            appear: Q(e, "appear", n),
            enter: Q(e, "enter", n),
            exit: Q(e, "exit", n)
          });
        })) : ee(e, r, i),
        firstRender: !1
      };
    }, o.handleExited = function (e, t) {
      var n = J(this.props.children);
      e.key in n || (e.props.onExited && e.props.onExited(t), this.mounted && this.setState(function (t) {
        var n = D({}, t.children);
        return delete n[e.key], {
          children: n
        };
      }));
    }, o.render = function () {
      var t = this.props,
        n = t.component,
        o = t.childFactory,
        r = j(t, ["component", "childFactory"]),
        i = this.state.contextValue,
        a = te(this.state.children).map(o);
      return delete r.appear, delete r.enter, delete r.exit, null === n ? e.createElement(Y.Provider, {
        value: i
      }, a) : e.createElement(Y.Provider, {
        value: i
      }, e.createElement(n, r, a));
    }, n;
  }(e.Component);
ne.propTypes = "production" !== process.env.NODE_ENV ? {
  component: m.any,
  children: m.node,
  appear: m.bool,
  enter: m.bool,
  exit: m.bool,
  childFactory: m.func
} : {}, ne.defaultProps = {
  component: "div",
  childFactory: function childFactory(e) {
    return e;
  }
};
var oe = function (t) {
  C(this, void 0);
  var n = t.isOpened,
    o = t.children,
    r = t.className,
    i = e.createElement("div", {
      id: "SRLLightbox",
      className: r
    }, o);
  return n && "undefined" != typeof window ? v.createPortal(i, document.body) : null;
}.bind(void 0);
oe.propTypes = {
  selector: m.string,
  isOpened: m.bool,
  children: m.oneOfType([m.arrayOf(m.node), m.node]).isRequired
};
var re = function re(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
};
function ie(e) {
  var t = {};
  return function (n) {
    return void 0 === t[n] && (t[n] = e(n)), t[n];
  };
}
var ae = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
  se = ie(function (e) {
    return ae.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
  });
var ce = function ce(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
};
var le = function () {
  function e(e) {
    this.isSpeedy = void 0 === e.speedy ? "production" === process.env.NODE_ENV : e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.before = null;
  }
  var t = e.prototype;
  return t.insert = function (e) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) == 0) {
      var t,
        n = function (e) {
          var t = document.createElement("style");
          return t.setAttribute("data-emotion", e.key), void 0 !== e.nonce && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t;
        }(this);
      t = 0 === this.tags.length ? this.before : this.tags[this.tags.length - 1].nextSibling, this.container.insertBefore(n, t), this.tags.push(n);
    }
    var o = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var r = function (e) {
        if (e.sheet) return e.sheet;
        for (var t = 0; t < document.styleSheets.length; t++) if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
      }(o);
      try {
        var i = 105 === e.charCodeAt(1) && 64 === e.charCodeAt(0);
        r.insertRule(e, i ? 0 : r.cssRules.length);
      } catch (t) {
        "production" !== process.env.NODE_ENV && console.warn('There was a problem inserting the following rule: "' + e + '"', t);
      }
    } else o.appendChild(document.createTextNode(e));
    this.ctr++;
  }, t.flush = function () {
    this.tags.forEach(function (e) {
      return e.parentNode.removeChild(e);
    }), this.tags = [], this.ctr = 0;
  }, e;
}();
function ue(e) {
  function t(e, t, o) {
    var r = t.trim().split(f);
    t = r;
    var i = r.length,
      a = e.length;
    switch (a) {
      case 0:
      case 1:
        var s = 0;
        for (e = 0 === a ? "" : e[0] + " "; s < i; ++s) t[s] = n(e, t[s], o).trim();
        break;
      default:
        var c = s = 0;
        for (t = []; s < i; ++s) for (var l = 0; l < a; ++l) t[c++] = n(e[l] + " ", r[s], o).trim();
    }
    return t;
  }
  function n(e, t, n) {
    var o = t.charCodeAt(0);
    switch (33 > o && (o = (t = t.trim()).charCodeAt(0)), o) {
      case 38:
        return t.replace(m, "$1" + e.trim());
      case 58:
        return e.trim() + t.replace(m, "$1" + e.trim());
      default:
        if (0 < 1 * n && 0 < t.indexOf("\f")) return t.replace(m, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
    }
    return e + t;
  }
  function o(e, t, n, i) {
    var a = e + ";",
      s = 2 * t + 3 * n + 4 * i;
    if (944 === s) {
      e = a.indexOf(":", 9) + 1;
      var c = a.substring(e, a.length - 1).trim();
      return c = a.substring(0, e).trim() + c + ";", 1 === N || 2 === N && r(c, 1) ? "-webkit-" + c + c : c;
    }
    if (0 === N || 2 === N && !r(a, 1)) return a;
    switch (s) {
      case 1015:
        return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
      case 951:
        return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
      case 963:
        return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
      case 1009:
        if (100 !== a.charCodeAt(4)) break;
      case 969:
      case 942:
        return "-webkit-" + a + a;
      case 978:
        return "-webkit-" + a + "-moz-" + a + a;
      case 1019:
      case 983:
        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
      case 883:
        if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
        if (0 < a.indexOf("image-set(", 11)) return a.replace(k, "$1-webkit-$2") + a;
        break;
      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
          case 115:
            return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
          case 98:
            return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
        }
        return "-webkit-" + a + "-ms-" + a + a;
      case 964:
        return "-webkit-" + a + "-ms-flex-" + a + a;
      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        return "-webkit-box-pack" + (c = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + a + "-ms-flex-pack" + c + a;
      case 1005:
        return p.test(a) ? a.replace(d, ":-webkit-") + a.replace(d, ":-moz-") + a : a;
      case 1e3:
        switch (t = (c = a.substring(13).trim()).indexOf("-") + 1, c.charCodeAt(0) + c.charCodeAt(t)) {
          case 226:
            c = a.replace(y, "tb");
            break;
          case 232:
            c = a.replace(y, "tb-rl");
            break;
          case 220:
            c = a.replace(y, "lr");
            break;
          default:
            return a;
        }
        return "-webkit-" + a + "-ms-" + c + a;
      case 1017:
        if (-1 === a.indexOf("sticky", 9)) break;
      case 975:
        switch (t = (a = e).length - 10, s = (c = (33 === a.charCodeAt(t) ? a.substring(0, t) : a).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | c.charCodeAt(7))) {
          case 203:
            if (111 > c.charCodeAt(8)) break;
          case 115:
            a = a.replace(c, "-webkit-" + c) + ";" + a;
            break;
          case 207:
          case 102:
            a = a.replace(c, "-webkit-" + (102 < s ? "inline-" : "") + "box") + ";" + a.replace(c, "-webkit-" + c) + ";" + a.replace(c, "-ms-" + c + "box") + ";" + a;
        }
        return a + ";";
      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return c = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + c + "-ms-flex-" + c + a;
          case 115:
            return "-webkit-" + a + "-ms-flex-item-" + a.replace(E, "") + a;
          default:
            return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(E, "") + a;
        }
        break;
      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
      case 931:
      case 953:
        if (!0 === C.test(e)) return 115 === (c = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? o(e.replace("stretch", "fill-available"), t, n, i).replace(":fill-available", ":stretch") : a.replace(c, "-webkit-" + c) + a.replace(c, "-moz-" + c.replace("fill-", "")) + a;
        break;
      case 962:
        if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === n + i && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(h, "$1-webkit-$2") + a;
    }
    return a;
  }
  function r(e, t) {
    var n = e.indexOf(1 === t ? ":" : "{"),
      o = e.substring(0, 3 !== t ? n : 10);
    return n = e.substring(n + 1, e.length - 1), R(2 !== t ? o : o.replace(S, "$1"), n, t);
  }
  function i(e, t) {
    var n = o(t, t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2));
    return n !== t + ";" ? n.replace(x, " or ($1)").substring(4) : "(" + t + ")";
  }
  function a(e, t, n, o, r, i, a, s, l, u) {
    for (var d, p = 0, h = t; p < P; ++p) switch (d = _[p].call(c, e, h, n, o, r, i, a, s, l, u)) {
      case void 0:
      case !1:
      case !0:
      case null:
        break;
      default:
        h = d;
    }
    if (h !== t) return h;
  }
  function s(e) {
    return void 0 !== (e = e.prefix) && (R = null, e ? "function" != typeof e ? N = 1 : (N = 2, R = e) : N = 0), s;
  }
  function c(e, n) {
    var s = e;
    if (33 > s.charCodeAt(0) && (s = s.trim()), s = [s], 0 < P) {
      var c = a(-1, n, s, s, T, L, 0, 0, 0, 0);
      void 0 !== c && "string" == typeof c && (n = c);
    }
    var d = function e(n, s, c, d, p) {
      for (var h, f, m, y, x, E = 0, S = 0, C = 0, k = 0, _ = 0, R = 0, F = m = h = 0, I = 0, B = 0, D = 0, j = 0, M = c.length, q = M - 1, V = "", W = "", U = "", Y = ""; I < M;) {
        if (f = c.charCodeAt(I), I === q && 0 !== S + k + C + E && (0 !== S && (f = 47 === S ? 10 : 47), k = C = E = 0, M++, q++), 0 === S + k + C + E) {
          if (I === q && (0 < B && (V = V.replace(u, "")), 0 < V.trim().length)) {
            switch (f) {
              case 32:
              case 9:
              case 59:
              case 13:
              case 10:
                break;
              default:
                V += c.charAt(I);
            }
            f = 59;
          }
          switch (f) {
            case 123:
              for (h = (V = V.trim()).charCodeAt(0), m = 1, j = ++I; I < M;) {
                switch (f = c.charCodeAt(I)) {
                  case 123:
                    m++;
                    break;
                  case 125:
                    m--;
                    break;
                  case 47:
                    switch (f = c.charCodeAt(I + 1)) {
                      case 42:
                      case 47:
                        e: {
                          for (F = I + 1; F < q; ++F) switch (c.charCodeAt(F)) {
                            case 47:
                              if (42 === f && 42 === c.charCodeAt(F - 1) && I + 2 !== F) {
                                I = F + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (47 === f) {
                                I = F + 1;
                                break e;
                              }
                          }
                          I = F;
                        }
                    }
                    break;
                  case 91:
                    f++;
                  case 40:
                    f++;
                  case 34:
                  case 39:
                    for (; I++ < q && c.charCodeAt(I) !== f;);
                }
                if (0 === m) break;
                I++;
              }
              switch (m = c.substring(j, I), 0 === h && (h = (V = V.replace(l, "").trim()).charCodeAt(0)), h) {
                case 64:
                  switch (0 < B && (V = V.replace(u, "")), f = V.charCodeAt(1)) {
                    case 100:
                    case 109:
                    case 115:
                    case 45:
                      B = s;
                      break;
                    default:
                      B = A;
                  }
                  if (j = (m = e(s, B, m, f, p + 1)).length, 0 < P && (x = a(3, m, B = t(A, V, D), s, T, L, j, f, p, d), V = B.join(""), void 0 !== x && 0 === (j = (m = x.trim()).length) && (f = 0, m = "")), 0 < j) switch (f) {
                    case 115:
                      V = V.replace(w, i);
                    case 100:
                    case 109:
                    case 45:
                      m = V + "{" + m + "}";
                      break;
                    case 107:
                      m = (V = V.replace(v, "$1 $2")) + "{" + m + "}", m = 1 === N || 2 === N && r("@" + m, 3) ? "@-webkit-" + m + "@" + m : "@" + m;
                      break;
                    default:
                      m = V + m, 112 === d && (W += m, m = "");
                  } else m = "";
                  break;
                default:
                  m = e(s, t(s, V, D), m, d, p + 1);
              }
              U += m, m = D = B = F = h = 0, V = "", f = c.charCodeAt(++I);
              break;
            case 125:
            case 59:
              if (1 < (j = (V = (0 < B ? V.replace(u, "") : V).trim()).length)) switch (0 === F && (h = V.charCodeAt(0), 45 === h || 96 < h && 123 > h) && (j = (V = V.replace(" ", ":")).length), 0 < P && void 0 !== (x = a(1, V, s, n, T, L, W.length, d, p, d)) && 0 === (j = (V = x.trim()).length) && (V = "\0\0"), h = V.charCodeAt(0), f = V.charCodeAt(1), h) {
                case 0:
                  break;
                case 64:
                  if (105 === f || 99 === f) {
                    Y += V + c.charAt(I);
                    break;
                  }
                default:
                  58 !== V.charCodeAt(j - 1) && (W += o(V, h, f, V.charCodeAt(2)));
              }
              D = B = F = h = 0, V = "", f = c.charCodeAt(++I);
          }
        }
        switch (f) {
          case 13:
          case 10:
            47 === S ? S = 0 : 0 === 1 + h && 107 !== d && 0 < V.length && (B = 1, V += "\0"), 0 < P * z && a(0, V, s, n, T, L, W.length, d, p, d), L = 1, T++;
            break;
          case 59:
          case 125:
            if (0 === S + k + C + E) {
              L++;
              break;
            }
          default:
            switch (L++, y = c.charAt(I), f) {
              case 9:
              case 32:
                if (0 === k + E + S) switch (_) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    y = "";
                    break;
                  default:
                    32 !== f && (y = " ");
                }
                break;
              case 0:
                y = "\\0";
                break;
              case 12:
                y = "\\f";
                break;
              case 11:
                y = "\\v";
                break;
              case 38:
                0 === k + S + E && (B = D = 1, y = "\f" + y);
                break;
              case 108:
                if (0 === k + S + E + O && 0 < F) switch (I - F) {
                  case 2:
                    112 === _ && 58 === c.charCodeAt(I - 3) && (O = _);
                  case 8:
                    111 === R && (O = R);
                }
                break;
              case 58:
                0 === k + S + E && (F = I);
                break;
              case 44:
                0 === S + C + k + E && (B = 1, y += "\r");
                break;
              case 34:
              case 39:
                0 === S && (k = k === f ? 0 : 0 === k ? f : k);
                break;
              case 91:
                0 === k + S + C && E++;
                break;
              case 93:
                0 === k + S + C && E--;
                break;
              case 41:
                0 === k + S + E && C--;
                break;
              case 40:
                if (0 === k + S + E) {
                  if (0 === h) switch (2 * _ + 3 * R) {
                    case 533:
                      break;
                    default:
                      h = 1;
                  }
                  C++;
                }
                break;
              case 64:
                0 === S + C + k + E + F + m && (m = 1);
                break;
              case 42:
              case 47:
                if (!(0 < k + E + C)) switch (S) {
                  case 0:
                    switch (2 * f + 3 * c.charCodeAt(I + 1)) {
                      case 235:
                        S = 47;
                        break;
                      case 220:
                        j = I, S = 42;
                    }
                    break;
                  case 42:
                    47 === f && 42 === _ && j + 2 !== I && (33 === c.charCodeAt(j + 2) && (W += c.substring(j, I + 1)), y = "", S = 0);
                }
            }
            0 === S && (V += y);
        }
        R = _, _ = f, I++;
      }
      if (0 < (j = W.length)) {
        if (B = s, 0 < P && void 0 !== (x = a(2, W, B, n, T, L, j, d, p, d)) && 0 === (W = x).length) return Y + W + U;
        if (W = B.join(",") + "{" + W + "}", 0 != N * O) {
          switch (2 !== N || r(W, 2) || (O = 0), O) {
            case 111:
              W = W.replace(b, ":-moz-$1") + W;
              break;
            case 112:
              W = W.replace(g, "::-webkit-input-$1") + W.replace(g, "::-moz-$1") + W.replace(g, ":-ms-input-$1") + W;
          }
          O = 0;
        }
      }
      return Y + W + U;
    }(A, s, n, 0, 0);
    return 0 < P && void 0 !== (c = a(-2, d, s, s, T, L, d.length, 0, 0, 0)) && (d = c), "", O = 0, L = T = 1, d;
  }
  var l = /^\0+/g,
    u = /[\0\r\f]/g,
    d = /: */g,
    p = /zoo|gra/,
    h = /([,: ])(transform)/g,
    f = /,\r+?/g,
    m = /([\t\r\n ])*\f?&/g,
    v = /@(k\w+)\s*(\S*)\s*/,
    g = /::(place)/g,
    b = /:(read-only)/g,
    y = /[svh]\w+-[tblr]{2}/,
    w = /\(\s*(.*)\s*\)/g,
    x = /([\s\S]*?);/g,
    E = /-self|flex-/g,
    S = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
    C = /stretch|:\s*\w+\-(?:conte|avail)/,
    k = /([^-])(image-set\()/,
    L = 1,
    T = 1,
    O = 0,
    N = 1,
    A = [],
    _ = [],
    P = 0,
    R = null,
    z = 0;
  return c.use = function e(t) {
    switch (t) {
      case void 0:
      case null:
        P = _.length = 0;
        break;
      default:
        if ("function" == typeof t) _[P++] = t;else if ("object" == typeof t) for (var n = 0, o = t.length; n < o; ++n) e(t[n]);else z = 0 | !!t;
    }
    return e;
  }, c.set = s, void 0 !== e && s(e), c;
}
var de = function de(e) {
  var t = new WeakMap();
  return function (n) {
    if (t.has(n)) return t.get(n);
    var o = e(n);
    return t.set(n, o), o;
  };
};
function pe(e) {
  e && he.current.insert(e + "}");
}
var he = {
    current: null
  },
  fe = function fe(e, t, n, o, r, i, a, s, c, l) {
    switch (e) {
      case 1:
        switch (t.charCodeAt(0)) {
          case 64:
            return he.current.insert(t + ";"), "";
          case 108:
            if (98 === t.charCodeAt(2)) return "";
        }
        break;
      case 2:
        if (0 === s) return t + "/*|*/";
        break;
      case 3:
        switch (s) {
          case 102:
          case 112:
            return he.current.insert(n[0] + t), "";
          default:
            return t + (0 === l ? "/*|*/" : "");
        }
      case -2:
        t.split("/*|*/}").forEach(pe);
    }
  },
  me = function me(e, t) {
    if (1 === e && 108 === t.charCodeAt(0) && 98 === t.charCodeAt(2)) return "";
  },
  ve = "undefined" != typeof document,
  ge = {},
  be = ve ? void 0 : de(function () {
    var e = de(function () {
        return {};
      }),
      t = {},
      n = {};
    return function (o) {
      return void 0 === o || !0 === o ? t : !1 === o ? n : e(o);
    };
  }),
  ye = function ye(e) {
    void 0 === e && (e = {});
    var t,
      n = e.key || "css";
    void 0 !== e.prefix && (t = {
      prefix: e.prefix
    });
    var o = new ue(t);
    if ("production" !== process.env.NODE_ENV && /[^a-z-]/.test(n)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
    var r,
      i,
      a = {};
    if (ve) {
      r = e.container || document.head;
      var s = document.querySelectorAll("style[data-emotion-" + n + "]");
      Array.prototype.forEach.call(s, function (e) {
        e.getAttribute("data-emotion-" + n).split(" ").forEach(function (e) {
          a[e] = !0;
        }), e.parentNode !== r && r.appendChild(e);
      });
    }
    if (ve) o.use(e.stylisPlugins)(fe), i = function i(e, t, n, r) {
      var i = t.name;
      if (he.current = n, "production" !== process.env.NODE_ENV && void 0 !== t.map) {
        var a = t.map;
        he.current = {
          insert: function insert(e) {
            n.insert(e + a);
          }
        };
      }
      o(e, t.styles), r && (d.inserted[i] = !0);
    };else {
      o.use(me);
      var c = ge;
      (e.stylisPlugins || void 0 !== e.prefix) && (o.use(e.stylisPlugins), c = be(e.stylisPlugins || ge)(e.prefix));
      i = function i(e, t, n, r) {
        var i = t.name,
          a = function (e, t) {
            var n = t.name;
            return void 0 === c[n] && (c[n] = o(e, t.styles)), c[n];
          }(e, t);
        return void 0 === d.compat ? (r && (d.inserted[i] = !0), "development" === process.env.NODE_ENV && void 0 !== t.map ? a + t.map : a) : r ? void (d.inserted[i] = a) : a;
      };
    }
    if ("production" !== process.env.NODE_ENV) {
      var l = /\/\*/g,
        u = /\*\//g;
      o.use(function (e, t) {
        switch (e) {
          case -1:
            for (; l.test(t);) {
              if (u.lastIndex = l.lastIndex, !u.test(t)) throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
              l.lastIndex = u.lastIndex;
            }
            l.lastIndex = 0;
        }
      }), o.use(function (e, t, n) {
        switch (e) {
          case -1:
            var o = t.match(/(:first|:nth|:nth-last)-child/g);
            o && !0 !== d.compat && o.forEach(function (e) {
              var n = new RegExp(e + ".*\\/\\* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason \\*\\/").test(t);
              e && !n && console.error('The pseudo class "' + e + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + e.split("-child")[0] + '-of-type".');
            });
        }
      });
    }
    var d = {
      key: n,
      sheet: new le({
        key: n,
        container: r,
        nonce: e.nonce,
        speedy: e.speedy
      }),
      nonce: e.nonce,
      inserted: a,
      registered: {},
      insert: i
    };
    return d;
  },
  we = "undefined" != typeof document;
function xe(e, t, n) {
  var o = "";
  return n.split(" ").forEach(function (n) {
    void 0 !== e[n] ? t.push(e[n]) : o += n + " ";
  }), o;
}
var Ee = function Ee(e, t, n) {
  var o = e.key + "-" + t.name;
  if ((!1 === n || !1 === we && void 0 !== e.compat) && void 0 === e.registered[o] && (e.registered[o] = t.styles), void 0 === e.inserted[t.name]) {
    var r = "",
      i = t;
    do {
      var a = e.insert("." + o, i, e.sheet, !0);
      we || void 0 === a || (r += a), i = i.next;
    } while (void 0 !== i);
    if (!we && 0 !== r.length) return r;
  }
};
var Se = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
  },
  Ce = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
  ke = /[A-Z]|^ms/g,
  Le = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
  Te = function Te(e) {
    return 45 === e.charCodeAt(1);
  },
  Oe = function Oe(e) {
    return null != e && "boolean" != typeof e;
  },
  Ne = ie(function (e) {
    return Te(e) ? e : e.replace(ke, "-$&").toLowerCase();
  }),
  Ae = function Ae(e, t) {
    switch (e) {
      case "animation":
      case "animationName":
        if ("string" == typeof t) return t.replace(Le, function (e, t, n) {
          return Me = {
            name: t,
            styles: n,
            next: Me
          }, t;
        });
    }
    return 1 === Se[e] || Te(e) || "number" != typeof t || 0 === t ? t : t + "px";
  };
if ("production" !== process.env.NODE_ENV) {
  var _e = /(attr|calc|counters?|url)\(/,
    Pe = ["normal", "none", "counter", "open-quote", "close-quote", "no-open-quote", "no-close-quote", "initial", "inherit", "unset"],
    Re = Ae,
    ze = /^-ms-/,
    Fe = /-(.)/g,
    Ie = {};
  Ae = function Ae(e, t) {
    "content" === e && ("string" != typeof t || -1 === Pe.indexOf(t) && !_e.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || '"' !== t.charAt(0) && "'" !== t.charAt(0))) && console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var n = Re(e, t);
    return "" === n || Te(e) || -1 === e.indexOf("-") || void 0 !== Ie[e] || (Ie[e] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + e.replace(ze, "ms-").replace(Fe, function (e, t) {
      return t.toUpperCase();
    }) + "?")), n;
  };
}
var Be = !0;
function De(e, t, n, o) {
  if (null == n) return "";
  if (void 0 !== n.__emotion_styles) {
    if ("production" !== process.env.NODE_ENV && "NO_COMPONENT_SELECTOR" === n.toString()) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object":
      if (1 === n.anim) return Me = {
        name: n.name,
        styles: n.styles,
        next: Me
      }, n.name;
      if (void 0 !== n.styles) {
        var r = n.next;
        if (void 0 !== r) for (; void 0 !== r;) Me = {
          name: r.name,
          styles: r.styles,
          next: Me
        }, r = r.next;
        var i = n.styles + ";";
        return "production" !== process.env.NODE_ENV && void 0 !== n.map && (i += n.map), i;
      }
      return function (e, t, n) {
        var o = "";
        if (Array.isArray(n)) for (var r = 0; r < n.length; r++) o += De(e, t, n[r], !1);else for (var i in n) {
          var a = n[i];
          if ("object" != typeof a) null != t && void 0 !== t[a] ? o += i + "{" + t[a] + "}" : Oe(a) && (o += Ne(i) + ":" + Ae(i, a) + ";");else {
            if ("NO_COMPONENT_SELECTOR" === i && "production" !== process.env.NODE_ENV) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
            if (!Array.isArray(a) || "string" != typeof a[0] || null != t && void 0 !== t[a[0]]) {
              var s = De(e, t, a, !1);
              switch (i) {
                case "animation":
                case "animationName":
                  o += Ne(i) + ":" + s + ";";
                  break;
                default:
                  "production" !== process.env.NODE_ENV && "undefined" === i && console.error("You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key)."), o += i + "{" + s + "}";
              }
            } else for (var c = 0; c < a.length; c++) Oe(a[c]) && (o += Ne(i) + ":" + Ae(i, a[c]) + ";");
          }
        }
        return o;
      }(e, t, n);
    case "function":
      if (void 0 !== e) {
        var a = Me,
          s = n(e);
        return Me = a, De(e, t, s, o);
      }
      "production" !== process.env.NODE_ENV && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    case "string":
      if ("production" !== process.env.NODE_ENV) {
        var c = [],
          l = n.replace(Le, function (e, t, n) {
            var o = "animation" + c.length;
            return c.push("const " + o + " = keyframes`" + n.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + o + "}";
          });
        c.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(c, ["`" + l + "`"]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\ncss`" + l + "`");
      }
  }
  if (null == t) return n;
  var u = t[n];
  return "production" !== process.env.NODE_ENV && o && Be && void 0 !== u && (console.error("Interpolating a className from css`` is not recommended and will cause problems with composition.\nInterpolating a className from css`` will be completely unsupported in a future major version of Emotion"), Be = !1), void 0 === u || o ? n : u;
}
var je,
  Me,
  qe = /label:\s*([^\s;\n{]+)\s*;/g;
"production" !== process.env.NODE_ENV && (je = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//);
var Ve = function Ve(e, t, n) {
    if (1 === e.length && "object" == typeof e[0] && null !== e[0] && void 0 !== e[0].styles) return e[0];
    var o = !0,
      r = "";
    Me = void 0;
    var i,
      a = e[0];
    null == a || void 0 === a.raw ? (o = !1, r += De(n, t, a, !1)) : ("production" !== process.env.NODE_ENV && void 0 === a[0] && console.error(Ce), r += a[0]);
    for (var s = 1; s < e.length; s++) r += De(n, t, e[s], 46 === r.charCodeAt(r.length - 1)), o && ("production" !== process.env.NODE_ENV && void 0 === a[s] && console.error(Ce), r += a[s]);
    "production" !== process.env.NODE_ENV && (r = r.replace(je, function (e) {
      return i = e, "";
    })), qe.lastIndex = 0;
    for (var c, l = ""; null !== (c = qe.exec(r));) l += "-" + c[1];
    var u = function (e) {
      for (var t, n = 0, o = 0, r = e.length; r >= 4; ++o, r -= 4) t = 1540483477 * (65535 & (t = 255 & e.charCodeAt(o) | (255 & e.charCodeAt(++o)) << 8 | (255 & e.charCodeAt(++o)) << 16 | (255 & e.charCodeAt(++o)) << 24)) + (59797 * (t >>> 16) << 16), n = 1540483477 * (65535 & (t ^= t >>> 24)) + (59797 * (t >>> 16) << 16) ^ 1540483477 * (65535 & n) + (59797 * (n >>> 16) << 16);
      switch (r) {
        case 3:
          n ^= (255 & e.charCodeAt(o + 2)) << 16;
        case 2:
          n ^= (255 & e.charCodeAt(o + 1)) << 8;
        case 1:
          n = 1540483477 * (65535 & (n ^= 255 & e.charCodeAt(o))) + (59797 * (n >>> 16) << 16);
      }
      return (((n = 1540483477 * (65535 & (n ^= n >>> 13)) + (59797 * (n >>> 16) << 16)) ^ n >>> 15) >>> 0).toString(36);
    }(r) + l;
    return "production" !== process.env.NODE_ENV ? {
      name: u,
      styles: r,
      map: i,
      next: Me,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    } : {
      name: u,
      styles: r,
      next: Me
    };
  },
  We = "undefined" != typeof document,
  Ue = l("undefined" != typeof HTMLElement ? ye() : null),
  Ye = l({}),
  He = (Ue.Provider, function (e) {
    return p(function (t, n) {
      return u(Ue.Consumer, null, function (o) {
        return e(t, o, n);
      });
    });
  });
if (!We) {
  var Ge = function (e) {
    function t(t, n, o) {
      var r;
      return (r = e.call(this, t, n, o) || this).state = {
        value: ye()
      }, r;
    }
    return ce(t, e), t.prototype.render = function () {
      return u(Ue.Provider, this.state, this.props.children(this.state.value));
    }, t;
  }(h);
  He = function He(e) {
    return function (t) {
      return u(Ue.Consumer, null, function (n) {
        return null === n ? u(Ge, null, function (n) {
          return e(t, n);
        }) : e(t, n);
      });
    };
  };
}
var $e = Object.prototype.hasOwnProperty,
  Ze = function Ze(e, t, n, o) {
    var r = null === n ? t.css : t.css(n);
    "string" == typeof r && void 0 !== e.registered[r] && (r = e.registered[r]);
    var i = t.__EMOTION_TYPE_PLEASE_DO_NOT_USE__,
      a = [r],
      s = "";
    "string" == typeof t.className ? s = xe(e.registered, a, t.className) : null != t.className && (s = t.className + " ");
    var c = Ve(a);
    if ("production" !== process.env.NODE_ENV && -1 === c.name.indexOf("-")) {
      var l = t.__EMOTION_LABEL_PLEASE_DO_NOT_USE__;
      l && (c = Ve([c, "label:" + l + ";"]));
    }
    var p = Ee(e, c, "string" == typeof i);
    s += e.key + "-" + c.name;
    var h = {};
    for (var f in t) !$e.call(t, f) || "css" === f || "__EMOTION_TYPE_PLEASE_DO_NOT_USE__" === f || "production" !== process.env.NODE_ENV && "__EMOTION_LABEL_PLEASE_DO_NOT_USE__" === f || (h[f] = t[f]);
    h.ref = o, h.className = s;
    var m = u(i, h);
    if (!We && void 0 !== p) {
      for (var v, g = c.name, b = c.next; void 0 !== b;) g += " " + b.name, b = b.next;
      return u(d, null, u("style", ((v = {})["data-emotion-" + e.key] = g, v.dangerouslySetInnerHTML = {
        __html: p
      }, v.nonce = e.sheet.nonce, v)), m);
    }
    return m;
  },
  Xe = He(function (e, t, n) {
    return "function" == typeof e.css ? u(Ye.Consumer, null, function (o) {
      return Ze(t, e, o, n);
    }) : Ze(t, e, null, n);
  });
"production" !== process.env.NODE_ENV && (Xe.displayName = "EmotionCssPropInternal");
var Ke = function e(t) {
  for (var n = t.length, o = 0, r = ""; o < n; o++) {
    var i = t[o];
    if (null != i) {
      var a = void 0;
      switch (typeof i) {
        case "boolean":
          break;
        case "object":
          if (Array.isArray(i)) a = e(i);else for (var s in a = "", i) i[s] && s && (a && (a += " "), a += s);
          break;
        default:
          a = i;
      }
      a && (r && (r += " "), r += a);
    }
  }
  return r;
};
function Je(e, t, n) {
  var o = [],
    r = xe(e, o, n);
  return o.length < 2 ? n : r + t(o);
}
He(function (e, t) {
  return u(Ye.Consumer, null, function (n) {
    var o,
      r = "",
      i = "",
      a = !1,
      s = function s() {
        if (a && "production" !== process.env.NODE_ENV) throw new Error("css can only be used during render");
        for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++) n[o] = arguments[o];
        var s = Ve(n, t.registered);
        if (We) Ee(t, s, !1);else {
          var c = Ee(t, s, !1);
          void 0 !== c && (r += c);
        }
        return We || (i += " " + s.name), t.key + "-" + s.name;
      },
      c = {
        css: s,
        cx: function cx() {
          if (a && "production" !== process.env.NODE_ENV) throw new Error("cx can only be used during render");
          for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++) n[o] = arguments[o];
          return Je(t.registered, s, Ke(n));
        },
        theme: n
      },
      l = e.children(c);
    return a = !0, We || 0 === r.length ? l : u(d, null, u("style", ((o = {})["data-emotion-" + t.key] = i.substring(1), o.dangerouslySetInnerHTML = {
      __html: r
    }, o.nonce = t.sheet.nonce, o)), l);
  });
});
var Qe = se,
  et = function et(e) {
    return "theme" !== e && "innerRef" !== e;
  },
  tt = function tt(e) {
    return "string" == typeof e && e.charCodeAt(0) > 96 ? Qe : et;
  };
function nt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function ot(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? nt(n, !0).forEach(function (t) {
      re(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nt(n).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
var rt = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
  it = "undefined" != typeof document,
  at = function e(t, n) {
    if ("production" !== process.env.NODE_ENV && void 0 === t) throw new Error("You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.");
    var o, r, i;
    void 0 !== n && (o = n.label, i = n.target, r = t.__emotion_forwardProp && n.shouldForwardProp ? function (e) {
      return t.__emotion_forwardProp(e) && n.shouldForwardProp(e);
    } : n.shouldForwardProp);
    var a = t.__emotion_real === t,
      s = a && t.__emotion_base || t;
    "function" != typeof r && a && (r = t.__emotion_forwardProp);
    var c = r || tt(s),
      l = !c("as");
    return function () {
      var p = arguments,
        h = a && void 0 !== t.__emotion_styles ? t.__emotion_styles.slice(0) : [];
      if (void 0 !== o && h.push("label:" + o + ";"), null == p[0] || void 0 === p[0].raw) h.push.apply(h, p);else {
        "production" !== process.env.NODE_ENV && void 0 === p[0][0] && console.error(rt), h.push(p[0][0]);
        for (var f = p.length, m = 1; m < f; m++) "production" !== process.env.NODE_ENV && void 0 === p[0][m] && console.error(rt), h.push(p[m], p[0][m]);
      }
      var v = He(function (e, t, n) {
        return u(Ye.Consumer, null, function (a) {
          var p = l && e.as || s,
            f = "",
            m = [],
            v = e;
          if (null == e.theme) {
            for (var g in v = {}, e) v[g] = e[g];
            v.theme = a;
          }
          "string" == typeof e.className ? f = xe(t.registered, m, e.className) : null != e.className && (f = e.className + " ");
          var b = Ve(h.concat(m), t.registered, v),
            y = Ee(t, b, "string" == typeof p);
          f += t.key + "-" + b.name, void 0 !== i && (f += " " + i);
          var w = l && void 0 === r ? tt(p) : c,
            x = {};
          for (var E in e) l && "as" === E || w(E) && (x[E] = e[E]);
          x.className = f, x.ref = n || e.innerRef, "production" !== process.env.NODE_ENV && e.innerRef && console.error("`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead" + (void 0 === o ? "" : " in the usage of `" + o + "`"));
          var S = u(p, x);
          if (!it && void 0 !== y) {
            for (var C, k = b.name, L = b.next; void 0 !== L;) k += " " + L.name, L = L.next;
            return u(d, null, u("style", ((C = {})["data-emotion-" + t.key] = k, C.dangerouslySetInnerHTML = {
              __html: y
            }, C.nonce = t.sheet.nonce, C)), S);
          }
          return S;
        });
      });
      return v.displayName = void 0 !== o ? o : "Styled(" + ("string" == typeof s ? s : s.displayName || s.name || "Component") + ")", v.defaultProps = t.defaultProps, v.__emotion_real = v, v.__emotion_base = s, v.__emotion_styles = h, v.__emotion_forwardProp = r, Object.defineProperty(v, "toString", {
        value: function value() {
          return void 0 === i && "production" !== process.env.NODE_ENV ? "NO_COMPONENT_SELECTOR" : "." + i;
        }
      }), v.withComponent = function (t, o) {
        return e(t, void 0 !== o ? ot({}, n || {}, {}, o) : n).apply(void 0, h);
      }, v;
    };
  }.bind();
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"].forEach(function (e) {
  at[e] = at(e);
});
function st() {
  var e = k(["\n  width: ", ";\n  height: ", ";\n  background-repeat: no-repeat;\n  background-size: cover;\n  margin: 1px;\n  opacity: ", ";\n  transition: opacity 0.3s ease;\n  display: block;\n  cursor: pointer;\n  flex: 0 0 auto;\n  &:first-of-type {\n    margin: 0;\n  }\n  &:last-child {\n    margin: 0;\n  }\n  &.SRLSelected {\n    opacity: 1;\n  }\n"]);
  return st = function st() {
    return e;
  }, e;
}
function ct() {
  var e = k(["\n  display: flex;\n  color: white;\n  height: auto;\n  width: 100%;\n  justify-content: center;\n  align-self: flex-end;\n  flex-wrap: wrap;\n  overflow-y: hidden;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  opacity: 1;\n  transition: opacity 0.3s ease;\n\n  @media (max-width: 768px) {\n    flex-wrap: nowrap;\n  }\n\n  .SRLIdle & {\n    opacity: 0;\n  }\n  @media (max-width: 768px) {\n    justify-content: start;\n  }\n"]);
  return ct = function ct() {
    return e;
  }, e;
}
function lt() {
  var e = k(["\n  top: calc(50% - 50px);\n  left: 5px;\n  left: calc(env(safe-area-inset-left) + 5px);\n  @media (max-width: 768px) {\n    display: none;\n  }\n"]);
  return lt = function lt() {
    return e;
  }, e;
}
function ut() {
  var e = k(["\n  top: calc(50% - 50px);\n  right: 5px;\n  right: calc(env(safe-area-inset-right) + 5px);\n  @media (max-width: 768px) {\n    display: none;\n  }\n"]);
  return ut = function ut() {
    return e;
  }, e;
}
function dt() {
  var e = k(["\n  position: relative;\n  margin-right: 5px;\n"]);
  return dt = function dt() {
    return e;
  }, e;
}
function pt() {
  var e = k(["\n  position: relative;\n  margin-right: 5px;\n  display: ", ";\n"]);
  return pt = function pt() {
    return e;
  }, e;
}
function ht() {
  var e = k(["\n  position: relative;\n  margin-right: 5px;\n"]);
  return ht = function ht() {
    return e;
  }, e;
}
function ft() {
  var e = k(["\n  position: relative;\n  margin-right: 5px;\n"]);
  return ft = function ft() {
    return e;
  }, e;
}
function mt() {
  var e = k(["\n  position: relative;\n"]);
  return mt = function mt() {
    return e;
  }, e;
}
function vt() {
  var e = k(["\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  top: calc(env(safe-area-inset-top) + 5px);\n  right: calc(env(safe-area-inset-right) + 5px);\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n"]);
  return vt = function vt() {
    return e;
  }, e;
}
function gt() {
  var e = k(["\n  position: absolute;\n  height: ", ";\n  width: ", ";\n  transition: color 0.3s ease;\n  background-color: ", ";\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  cursor: pointer;\n  display: inline-block;\n  margin: 0;\n  visibility: inherit;\n  z-index: 9992;\n  opacity: 1;\n  transition: opacity 0.3s ease;\n  .SRLIdle & {\n    opacity: 0;\n  }\n  @media (max-width: 768px) {\n    height: ", ";\n    width: ", ";\n  }\n  &:focus {\n    outline: none;\n  }\n  div {\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    width: 100%;\n    padding: ", ";\n    box-sizing: border-box;\n    svg {\n      display: block;\n      height: 100%;\n      width: auto;\n      overflow: visible;\n      position: relative;\n      path {\n        transition: fill 0.3s ease;\n        fill: ", ";\n      }\n    }\n    &:hover {\n      svg path {\n        fill: ", ";\n      }\n    }\n  }\n"]);
  return gt = function gt() {
    return e;
  }, e;
}
function bt() {
  var e = k(["\n  color: white;\n  font-family: inherit;\n  margin-top: 20px;\n  width: 100%;\n  text-align: center;\n  @media (max-width: 768px) {\n    margin-top: 0;\n  }\n  p {\n    margin: 0;\n    padding: 0;\n    text-align: center;\n    background-color: transparent;\n    @media (max-width: 768px) {\n      padding: 0 15px;\n    }\n    font-weight: ", ";\n    font-size: ", ";\n    font-family: ", ";\n    color: ", ";\n    font-style: ", ";\n    text-transform: ", ";\n  }\n"]);
  return bt = function bt() {
    return e;
  }, e;
}
function yt() {
  var e = k(["\n  background: transparent;\n  border: 0;\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  transition: opacity 500ms ease;\n  opacity: 1;\n  margin: auto;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"]);
  return yt = function yt() {
    return e;
  }, e;
}
function wt() {
  var e = k(["\n  top: 0;\n  left: 0;\n  position: relative;\n  transform-origin: 50% 50% !important;\n  cursor: grab;\n"]);
  return wt = function wt() {
    return e;
  }, e;
}
function xt() {
  var e = k(["\n  background: transparent;\n  border: 0;\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  transition: all 200ms ease;\n  opacity: 1;\n  margin: auto;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  cursor: ", ";\n"]);
  return xt = function xt() {
    return e;
  }, e;
}
function Et() {
  var e = k(["\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  outline: none;\n  border: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  &.element-transition-enter {\n    opacity: 0;\n  }\n  &.element-transition-enter-active {\n    opacity: 1;\n    transition-timing-function: ", ";\n    transition-duration: ", ";\n    transition-property: opacity;\n  }\n  &.element-transition-exit {\n    opacity: 1;\n  }\n  &.element-transition-exit-active {\n    opacity: 0;\n    transition-timing-function: ", ";\n    transition-duration: ", ";\n    transition-property: opacity;\n  }\n  &.element-transition-enter-done {\n    opacity: 1;\n    transition-timing-function: ", ";\n    transition-duration: ", ";\n    transition-property: opacity;\n  }\n"]);
  return Et = function Et() {
    return e;
  }, e;
}
function St() {
  var e = k(["\n  width: ", ";\n  height: ", ";\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin-top: ", ";\n  position: relative;\n  @media (max-width: 768px) {\n    width: 100vw;\n    height: ", ";\n  }\n  > div,\n  .SRLTransitionGroup {\n    width: 100%;\n    height: 100%;\n    outline: none;\n  }\n"]);
  return St = function St() {
    return e;
  }, e;
}
function Ct() {
  var e = k(["\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n"]);
  return Ct = function Ct() {
    return e;
  }, e;
}
function kt() {
  var e = k(["\n  background-color: ", ";\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 9991;\n"]);
  return kt = function kt() {
    return e;
  }, e;
}
var Lt = at.div(kt(), function (e) {
    return C(this, void 0), e.overlayColor;
  }.bind(void 0)),
  Tt = at.div(Ct()),
  Ot = at.div(St(), function (e) {
    return C(this, void 0), !1 === e.showThumbnails && !1 == !!e.showCaption ? "90vw" : !1 === e.showThumbnails && !0 === e.showCaption ? "85vw" : !0 === e.showThumbnails && !1 === e.showCaption ? "75vw" : "70vw";
  }.bind(void 0), function (e) {
    return C(this, void 0), !1 === e.showThumbnails && !1 == !!e.showCaption ? "90vh" : !1 === e.showThumbnails && !0 === e.showCaption ? "85vh" : !0 === e.showThumbnails && !1 === e.showCaption ? "75vh" : "70vh";
  }.bind(void 0), function (e) {
    return C(this, void 0), !1 === e.showThumbnails && !1 == !!e.showCaption ? "0px" : (!1 === e.showThumbnails && !0 === e.showCaption || !0 === e.showThumbnails && e.showCaption, "auto");
  }.bind(void 0), function (e) {
    return C(this, void 0), e.showThumbnails ? "70vh" : "80vh";
  }.bind(void 0)),
  Nt = at.div(Et(), function (e) {
    return C(this, void 0), e.slideTransitionTimingFunction ? e.slideTransitionTimingFunction : "ease";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.slideTransitionSpeed ? e.slideTransitionSpeed + "ms" : "600ms";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.slideTransitionTimingFunction ? e.slideTransitionTimingFunction : "ease";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.slideTransitionSpeed ? e.slideTransitionSpeed + "ms" : "600ms";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.slideTransitionTimingFunction ? e.slideTransitionTimingFunction : "ease";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.slideTransitionSpeed ? e.slideTransitionSpeed + "ms" : "600ms";
  }.bind(void 0)),
  At = at.img(xt(), function (e) {
    return C(this, void 0), e.disablePanzoom ? "auto" : "zoom-in";
  }.bind(void 0)),
  _t = at(At)(wt()),
  Pt = (at.video(yt()), at.div(bt(), function (e) {
    return C(this, void 0), e.captionStyle.captionFontWeight ? e.captionStyle.captionFontWeight : "inherit";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.captionStyle.captionFontSize ? e.captionStyle.captionFontSize : "inherit";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.captionStyle.captionColor ? e.captionStyle.captionFontFamily : "inherit";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.captionStyle.captionColor ? e.captionStyle.captionColor : "white";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.captionStyle.captionFontStyle ? e.captionStyle.captionFontStyle : "inherit";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.captionStyle.captionTextTransform ? e.captionStyle.captionTextTransform : "inherit";
  }.bind(void 0))),
  Rt = at.button(gt(), function (e) {
    return C(this, void 0), e.buttonsSize ? e.buttonsSize : "30px";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.buttonsSize ? e.buttonsSize : "30px";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.buttonsBackgroundColor ? e.buttonsBackgroundColor : "rgba(30, 30, 36, 0.8)";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.buttonsSize ? Math.round(parseInt(e.buttonsSize, 10) / 1.3) + "px" : "30px";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.buttonsSize ? Math.round(parseInt(e.buttonsSize, 10) / 1.3) + "px" : "30px";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.buttonsIconPadding ? e.buttonsIconPadding : "5px";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.buttonsIconColor ? e.buttonsIconColor : "rgba(255, 255, 255, 0.8)";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.buttonsIconColor && e.buttonsIconColor.replace(/[\d\.]+\)$/g, "1)");
  }.bind(void 0)),
  zt = at.div(vt()),
  Ft = at(Rt)(mt()),
  It = at(Rt)(ft()),
  Bt = at(Rt)(ht()),
  Dt = at(Rt)(pt(), function (e) {
    return C(this, void 0), 0 === e.autoplaySpeed ? "none" : "block";
  }.bind(void 0)),
  jt = at(Rt)(dt()),
  Mt = at(Rt)(ut()),
  qt = at(Rt)(lt()),
  Vt = at.div(ct()),
  Wt = at.a(st(), function (e) {
    return C(this, void 0), e.thumbnailsSize ? e.thumbnailsSize[0] : "80px";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.thumbnailsSize ? e.thumbnailsSize[1] : "80px";
  }.bind(void 0), function (e) {
    return C(this, void 0), e.thumbnailsOpacity ? e.thumbnailsOpacity : "0.4";
  }.bind(void 0)),
  Ut = function (t) {
    var n = this;
    C(this, void 0);
    var o = t.elements,
      r = t.currentId,
      i = t.handleCurrentElement,
      a = t.thumbnailsOpacity,
      s = t.thumbnailsSize;
    return e.createElement(Vt, {
      className: "SRLThumbnails"
    }, o.map(function (t, o) {
      var c = this;
      return C(this, n), e.createElement(Wt, {
        onClick: function () {
          return C(this, c), i(t.id);
        }.bind(this),
        thumbnailsOpacity: a,
        thumbnailsSize: s,
        key: o,
        className: "SRLThumb SRLThumb".concat(o, " ").concat(r === t.id ? "SRLSelected" : ""),
        style: {
          backgroundImage: "url('".concat(t.thumbnail, "')")
        }
      });
    }.bind(this)));
  }.bind(void 0);
function Yt() {
  return (Yt = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }).apply(this, arguments);
}
Ut.propTypes = {
  elements: m.array,
  handleCurrentElement: m.func,
  currentId: m.string,
  thumbnailsOpacity: m.number,
  thumbnailsSize: m.array
};
var Ht = {
    preventDefaultTouchmoveEvent: !1,
    delta: 10,
    rotationAngle: 0,
    trackMouse: !1,
    trackTouch: !0
  },
  Gt = {
    xy: [0, 0],
    swiping: !1,
    eventData: void 0,
    start: void 0
  };
function $t(e, t) {
  if (0 === t) return e;
  var n = Math.PI / 180 * t;
  return [e[0] * Math.cos(n) + e[1] * Math.sin(n), e[1] * Math.cos(n) - e[0] * Math.sin(n)];
}
function Zt(e, t) {
  var n = function n(t) {
      t.touches && t.touches.length > 1 || e(function (e, n) {
        n.trackMouse && (document.addEventListener("mousemove", o), document.addEventListener("mouseup", a));
        var r = t.touches ? t.touches[0] : t,
          i = $t([r.clientX, r.clientY], n.rotationAngle);
        return Yt({}, e, Gt, {
          eventData: {
            initial: [].concat(i),
            first: !0
          },
          xy: i,
          start: t.timeStamp || 0
        });
      });
    },
    o = function o(t) {
      e(function (e, n) {
        if (!e.xy[0] || !e.xy[1] || t.touches && t.touches.length > 1) return e;
        var o = t.touches ? t.touches[0] : t,
          r = $t([o.clientX, o.clientY], n.rotationAngle),
          i = r[0],
          a = r[1],
          s = e.xy[0] - i,
          c = e.xy[1] - a,
          l = Math.abs(s),
          u = Math.abs(c),
          d = (t.timeStamp || 0) - e.start,
          p = Math.sqrt(l * l + u * u) / (d || 1);
        if (l < n.delta && u < n.delta && !e.swiping) return e;
        var h = function (e, t, n, o) {
            return e > t ? n > 0 ? "Left" : "Right" : o > 0 ? "Up" : "Down";
          }(l, u, s, c),
          f = Yt({}, e.eventData, {
            event: t,
            absX: l,
            absY: u,
            deltaX: s,
            deltaY: c,
            velocity: p,
            dir: h
          });
        n.onSwiping && n.onSwiping(f);
        var m = !1;
        return (n.onSwiping || n.onSwiped || n["onSwiped" + h]) && (m = !0), m && n.preventDefaultTouchmoveEvent && n.trackTouch && t.cancelable && t.preventDefault(), Yt({}, e, {
          eventData: Yt({}, f, {
            first: !1
          }),
          swiping: !0
        });
      });
    },
    r = function r(t) {
      e(function (e, n) {
        var o;
        return e.swiping && (o = Yt({}, e.eventData, {
          event: t
        }), n.onSwiped && n.onSwiped(o), n["onSwiped" + o.dir] && n["onSwiped" + o.dir](o)), Yt({}, e, Gt, {
          eventData: o
        });
      });
    },
    i = function i() {
      document.removeEventListener("mousemove", o), document.removeEventListener("mouseup", a);
    },
    a = function a(e) {
      i(), r(e);
    },
    s = function s(e) {
      if (e && e.addEventListener) {
        var t = [["touchstart", n], ["touchmove", o], ["touchend", r]];
        return t.forEach(function (t) {
          var n = t[0],
            o = t[1];
          return e.addEventListener(n, o);
        }), function () {
          return t.forEach(function (t) {
            var n = t[0],
              o = t[1];
            return e.removeEventListener(n, o);
          });
        };
      }
    },
    c = {
      ref: function ref(t) {
        null !== t && e(function (e, n) {
          if (e.el === t) return e;
          var o = {};
          return e.el && e.el !== t && e.cleanUpTouch && (e.cleanUpTouch(), o.cleanUpTouch = null), n.trackTouch && t && (o.cleanUpTouch = s(t)), Yt({}, e, {
            el: t
          }, o);
        });
      }
    };
  return t.trackMouse && (c.onMouseDown = n), [c, s];
}
function Xt(e, t, n) {
  var o = {};
  return !t.trackTouch && e.cleanUpTouch ? (e.cleanUpTouch(), o.cleanUpTouch = null) : t.trackTouch && !e.cleanUpTouch && e.el && (o.cleanUpTouch = n(e.el)), Yt({}, e, o);
}
var Kt = function (t) {
  var n, o;
  function r(e) {
    var n;
    return (n = t.call(this, e) || this)._set = function (e) {
      n.transientState = e(n.transientState, n.props);
    }, n.transientState = Yt({}, Gt, {
      type: "class"
    }), n;
  }
  return o = t, (n = r).prototype = Object.create(o.prototype), n.prototype.constructor = n, n.__proto__ = o, r.prototype.render = function () {
    var t = this.props,
      n = t.className,
      o = t.style,
      r = t.nodeName,
      i = void 0 === r ? "div" : r,
      a = t.innerRef,
      s = t.children,
      c = t.trackMouse,
      l = Zt(this._set, {
        trackMouse: c
      }),
      u = l[0],
      d = l[1];
    this.transientState = Xt(this.transientState, this.props, d);
    var p = a ? function (e) {
      return a(e), u.ref(e);
    } : u.ref;
    return e.createElement(i, Yt({}, u, {
      className: n,
      style: o,
      ref: p
    }), s);
  }, r;
}(e.PureComponent);
Kt.propTypes = {
  onSwiped: m.func,
  onSwiping: m.func,
  onSwipedUp: m.func,
  onSwipedRight: m.func,
  onSwipedDown: m.func,
  onSwipedLeft: m.func,
  delta: m.number,
  preventDefaultTouchmoveEvent: m.bool,
  nodeName: m.string,
  trackMouse: m.bool,
  trackTouch: m.bool,
  innerRef: m.func,
  rotationAngle: m.number
}, Kt.defaultProps = Ht;
var Jt = P(function (e, t) {
  !function () {
    function t(e, t, n, o) {
      var r = "removeEventListener",
        i = function i() {
          e[r](t, n);
        };
      return e.addEventListener ? (e.addEventListener(t, n, o), i) : e.attachEvent ? (t = "on" + t, e.attachEvent(t, n), r = "detachEvent", i) : e.on ? (e.on(t, n), r = "off", i) : void 0;
    }
    t.define = function (e, t) {
      return function (n, o, r, i) {
        return n[e](o, r, i), function () {
          n[t](o, r);
        };
      };
    }, e.exports = t;
  }();
});
function Qt(t) {
  var n = this,
    r = t.caption,
    a = t.elements,
    s = t.handleCloseLightbox,
    c = t.handleCurrentElement,
    l = t.handleNextElement,
    u = t.handlePanzoom,
    d = t.handlePrevElement,
    p = t.height,
    h = t.id,
    m = t.options,
    v = t.panzoomEnabled,
    b = t.source,
    y = t.SRLLightboxPanzoomImageRef,
    w = t.width,
    E = m.settings,
    S = m.thumbnails,
    k = m.caption,
    T = function (t) {
      var n = t.trackMouse,
        o = e.useRef(Yt({}, Gt, {
          type: "hook"
        })),
        r = e.useRef();
      r.current = Yt({}, Ht, t);
      var i = e.useMemo(function () {
          return Zt(function (e) {
            return o.current = e(o.current, r.current);
          }, {
            trackMouse: n
          });
        }, [n]),
        a = i[0],
        s = i[1];
      return o.current = Xt(o.current, r.current, s), a;
    }({
      onSwipedLeft: function () {
        return C(this, n), l(h);
      }.bind(this),
      onSwipedRight: function () {
        return C(this, n), d(h);
      }.bind(this)
    }),
    O = L(function (e, t, n) {
      void 0 === n && (n = {});
      var r = n.maxWait,
        a = o(null),
        s = o([]),
        c = n.leading,
        l = void 0 === n.trailing || n.trailing,
        u = o(!1),
        d = o(null),
        p = o(!1),
        h = o(e);
      h.current = e;
      var m = f(function () {
        clearTimeout(d.current), clearTimeout(a.current), a.current = null, s.current = [], d.current = null, u.current = !1;
      }, []);
      i(function () {
        return function () {
          p.current = !0;
        };
      }, []);
      var v = f(function () {
          for (var e = [], n = 0; n < arguments.length; n++) e[n] = arguments[n];
          s.current = e, clearTimeout(d.current), u.current && (u.current = !1), d.current || !c || u.current || (h.current.apply(h, e), u.current = !0), d.current = setTimeout(function () {
            var t = !0;
            c && u.current && (t = !1), m(), !p.current && l && t && h.current.apply(h, e);
          }, t), r && !a.current && l && (a.current = setTimeout(function () {
            var e = s.current;
            m(), p.current || h.current.apply(null, e);
          }, r));
        }, [r, t, m, c, l]),
        g = f(function () {
          d.current && (h.current.apply(null, s.current), m());
        }, [m]);
      return [v, m, g];
    }(function (e) {
      C(this, n), e > 0 ? l(h) : e < 0 && d(h);
    }.bind(this), 150), 1)[0],
    N = o(),
    A = o();
  i(function () {
    var e = this;
    if (C(this, n), !v) {
      var t = Jt(document, "wheel", function (t) {
        return C(this, e), O(t.deltaY);
      }.bind(this));
      return function () {
        C(this, e), t();
      }.bind(this);
    }
  }.bind(this), [O, v, E.disableWheelControls]), function (e, t) {
    var n = this;
    i(function () {
      var o = this;
      C(this, n);
      var r = function (n) {
        C(this, o), !e.current || e.current.contains(n.target) || n.target.classList.contains("SRLNextButton") || n.target.classList.contains("SRLPrevButton") || n.target.classList.contains("SRLCloseButton") || n.target.classList.contains("SRLAutoplayButton") || n.target.classList.contains("SRLExpandButton") || n.target.classList.contains("SRLZoomOutButton") || n.target.classList.contains("SRLDownloadButton") || n.target.classList.contains("SRLThumbnails") || n.target.classList.contains("SRLThumb") || n.target.classList.contains("SRLCaption") || n.target.classList.contains("panzoom-enabled ") || n.target.classList.contains("element-transition-enter") || n.target.classList.contains("element-transition-enter-active") || n.target.classList.contains("element-transition-exit") || n.target.classList.contains("element-transition-exit-active") || "touchstart" === n.type || 0 !== n.button || t(n);
      }.bind(this);
      return "undefined" != typeof window && (document.addEventListener("mousedown", r), document.addEventListener("touchstart", r)), function () {
        C(this, o), "undefined" != typeof window && (document.removeEventListener("mousedown", r), document.removeEventListener("touchstart", r));
      }.bind(this);
    }.bind(this), [e, t]);
  }(A, function () {
    return C(this, n), s();
  }.bind(this));
  var _ = {
    captionColor: m.caption.captionColor,
    captionFontFamily: m.caption.captionFontFamily,
    captionFontSize: m.caption.captionFontSize,
    captionFontStyle: m.caption.captionFontStyle,
    captionFontWeight: m.caption.captionFontWeight,
    captionTextTransform: m.caption.captionTextTransform
  };
  return e.createElement(Tt, {
    className: "SRLContent",
    onWheel: function (e) {
      return C(this, n), O(e);
    }.bind(this),
    ref: N
  }, e.createElement(Ot, x({
    showThumbnails: S.showThumbnails,
    showCaption: k.showCaption,
    className: "SRLElementContainer",
    ref: A
  }, T), e.createElement(ne, {
    className: "SRLTransitionGroup"
  }, e.createElement(X, {
    key: h,
    classNames: "element-transition",
    timeout: E.slideTransitionSpeed
  }, e.createElement(Nt, {
    slideTransitionSpeed: E.slideTransitionSpeed,
    slideTransitionTimingFunction: E.slideTransitionTimingFunction,
    className: "SRLElementWrapper"
  }, v ? e.createElement(_t, {
    className: "SRLPanzoomImage",
    ref: y,
    width: w,
    height: p,
    src: "object" === g(b) ? "Loading..." : b,
    alt: r
  }) : e.createElement(At, {
    className: "SRLImage",
    disablePanzoom: E.disablePanzoom,
    width: w,
    height: p,
    onClick: function () {
      return C(this, n), u(!0);
    }.bind(this),
    src: "object" === g(b) ? "Loading..." : b,
    alt: r
  }))))), k.showCaption && e.createElement(Pt, {
    captionStyle: _,
    className: "SRLCaption"
  }, e.createElement("p", {
    className: "SRLCaption"
  }, r)), S.showThumbnails && e.createElement(Ut, {
    handleCurrentElement: c,
    thumbnailsOpacity: S.thumbnailsOpacity,
    thumbnailsSize: S.thumbnailsSize,
    currentId: h,
    elements: a || []
  }));
}
Qt.propTypes = {
  source: m.oneOfType([m.string, m.object]),
  caption: m.string,
  elements: m.array,
  width: m.number,
  height: m.number,
  handleCloseLightbox: m.func,
  handleCurrentElement: m.func,
  handleNextElement: m.func,
  handlePrevElement: m.func,
  handlePanzoom: m.func,
  id: m.string,
  SRLLightboxPanzoomImageRef: m.object,
  panzoomEnabled: m.bool,
  thumbnailsOpacity: m.number,
  options: m.shape({
    settings: m.shape({
      disableWheelControls: m.bool,
      disablePanzoom: m.bool,
      slideTransitionSpeed: m.number,
      slideTransitionTimingFunction: m.string
    }),
    caption: m.shape({
      showCaption: m.bool,
      captionColor: m.string,
      captionFontFamily: m.string,
      captionFontSize: m.string,
      captionFontStyle: m.string,
      captionFontWeight: m.string,
      captionTextTransform: m.string
    }),
    thumbnails: m.shape({
      showThumbnails: m.bool,
      thumbnailsOpacity: m.number,
      thumbnailsSize: m.array
    })
  })
};
var en = function (t) {
  var n = this;
  C(this, void 0);
  var o = t.handleCloseLightbox,
    r = t.handleNextElement,
    i = t.handlePrevElement,
    a = t.handleFullScreen,
    s = t.handleImageDownload,
    c = t.autoplay,
    l = t.settings,
    u = t.setAutoplay,
    d = t.currentElementID,
    p = t.buttons,
    h = t.panzoomEnabled,
    f = t.handlePanzoom;
  return e.createElement(e.Fragment, null, e.createElement(zt, {
    className: "SRLControls"
  }, p.showAutoplayButton && e.createElement(Dt, {
    buttonsBackgroundColor: p.backgroundColor,
    buttonsIconColor: p.iconColor,
    buttonsSize: p.size,
    buttonsIconPadding: p.iconPadding,
    autoplaySpeed: l.autoplaySpeed,
    title: "Autoplay",
    className: "SRLAutoplayButton",
    onClick: function () {
      return C(this, n), u(!c);
    }.bind(this)
  }, e.createElement("div", {
    className: "SRLAutoplayButton"
  }, c ? e.createElement("svg", {
    className: "SRLAutoplayButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, e.createElement("path", {
    className: "SRLAutoplayButton",
    d: "M14.2 38.7h5.9c1.6 0 2.9-1.3 2.9-2.9V14.2c0-1.6-1.3-2.9-2.9-2.9h-5.9c-1.6 0-2.9 1.3-2.9 2.9v21.6c0 1.6 1.3 2.9 2.9 2.9zm-1-24.5c0-.5.4-1 1-1h5.9c.5 0 1 .4 1 1v21.6c0 .5-.4 1-1 1h-5.9c-.5 0-1-.4-1-1V14.2zm16.7 24.5h5.9c1.6 0 2.9-1.3 2.9-2.9V14.2c0-1.6-1.3-2.9-2.9-2.9h-5.9c-1.6 0-2.9 1.3-2.9 2.9v21.6c0 1.6 1.3 2.9 2.9 2.9zm-1-24.5c0-.5.4-1 1-1h5.9c.5 0 1 .4 1 1v21.6c0 .5-.4 1-1 1h-5.9c-.5 0-1-.4-1-1V14.2z"
  })) : e.createElement("svg", {
    className: "SRLAutoplayButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, e.createElement("path", {
    className: "SRLAutoplayButton",
    d: "M35.7 22.8L16.9 11.6c-1.5-.9-3.9 0-3.9 2.2v22.3c0 2 2.2 3.2 3.9 2.2l18.9-11.1c1.6-1 1.6-3.4-.1-4.4zm-.8 2.9L16 36.9c-.6.3-1.3-.1-1.3-.7V13.8c0-.9.9-1 1.3-.7l18.9 11.1c.5.4.5 1.2 0 1.5z"
  })))), p.showDownloadButton && e.createElement(jt, {
    buttonsBackgroundColor: p.backgroundColor,
    buttonsIconColor: p.iconColor,
    buttonsSize: p.size,
    buttonsIconPadding: p.iconPadding,
    title: "Download",
    className: "SRLDownloadButton",
    onClick: s
  }, e.createElement("div", {
    className: "SRLDownloadButton"
  }, e.createElement("svg", {
    className: "SRLDownloadButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, e.createElement("path", {
    className: "SRLDownloadButton",
    d: "M35.7 34.1c0 .6-.5 1-1.1 1-.6 0-1.1-.5-1.1-1s.5-1 1.1-1c.6 0 1.1.5 1.1 1zm-4.6-1c-.6 0-1.1.5-1.1 1s.5 1 1.1 1c.6 0 1.1-.5 1.1-1s-.5-1-1.1-1zm7.8-2.5V36c0 1.3-1.1 2.3-2.4 2.3h-23c-1.3 0-2.4-1-2.4-2.3v-5.4c0-1.3 1.1-2.3 2.4-2.3h5.4l-3.1-2.9c-1.4-1.3-.4-3.5 1.5-3.5h2.9v-8.1c0-1.1 1-2.1 2.2-2.1h5.2c1.2 0 2.2.9 2.2 2.1v8.1h2.9c1.9 0 2.9 2.2 1.5 3.5l-3.1 2.9h5.4c1.3 0 2.4 1 2.4 2.3zm-14.2.9c.2.2.4.2.6 0l7.6-7.3c.3-.3.1-.7-.3-.7H28v-9.7c0-.2-.2-.4-.4-.4h-5.2c-.2 0-.4.2-.4.4v9.7h-4.6c-.4 0-.6.4-.3.7l7.6 7.3zm12.5-.9c0-.3-.3-.6-.7-.6h-7.1l-2.8 2.7c-.8.8-2.2.8-3.1 0L20.6 30h-7.1c-.4 0-.7.3-.7.6V36c0 .3.3.6.7.6h23c.4 0 .7-.3.7-.6v-5.4z"
  })))), h ? e.createElement(Bt, {
    buttonsBackgroundColor: p.backgroundColor,
    buttonsIconColor: p.iconColor,
    buttonsSize: p.size,
    buttonsIconPadding: p.iconPadding,
    title: "Zoom Out",
    className: "SRLZoomOutButton",
    onClick: function () {
      return C(this, n), f(!1);
    }.bind(this)
  }, e.createElement("div", {
    className: "SRLZoomOutButton"
  }, e.createElement("svg", {
    className: "SRLZoomOutButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, e.createElement("path", {
    className: "SRLZoomOutButton",
    d: "M27.9 21.6v1.3c0 .4-.3.7-.7.7h-10c-.4 0-.7-.3-.7-.7v-1.3c0-.4.3-.7.7-.7h10c.4 0 .7.3.7.7zm10.7 15.8l-1.2 1.2c-.3.3-.7.3-.9 0L29.9 32c-.1-.1-.2-.3-.2-.5v-.7c-2 1.7-4.6 2.8-7.4 2.8C16 33.6 11 28.5 11 22.3s5-11.4 11.3-11.4S33.6 16 33.6 22.3c0 2.8-1 5.4-2.8 7.4h.7c.2 0 .3.1.5.2l6.6 6.6c.3.2.3.6 0 .9zM31 22.3c0-4.8-3.9-8.7-8.7-8.7s-8.7 3.9-8.7 8.7 3.9 8.7 8.7 8.7 8.7-3.9 8.7-8.7z"
  })))) : "", p.showFullscreenButton && e.createElement(It, {
    buttonsBackgroundColor: p.backgroundColor,
    buttonsIconColor: p.iconColor,
    buttonsSize: p.size,
    buttonsIconPadding: p.iconPadding,
    title: "Expand",
    className: "SRLExpandButton",
    onClick: function () {
      return C(this, n), a();
    }.bind(this)
  }, e.createElement("div", {
    className: "SRLExpandButton"
  }, e.createElement("svg", {
    className: "SRLExpandButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, e.createElement("path", {
    className: "SRLExpandButton",
    d: "M11.22 20.66v-7.91a1.52 1.52 0 011.53-1.53h7.91a.76.76 0 01.76.76v1.53a.77.77 0 01-.76.77h-6.38v6.38a.77.77 0 01-.77.76H12a.76.76 0 01-.78-.76zM29.58 12v1.53a.78.78 0 00.77.77h6.38v6.38a.76.76 0 00.76.76H39a.77.77 0 00.77-.76v-7.93a1.52 1.52 0 00-1.53-1.53h-7.89a.77.77 0 00-.77.78zM39 29.58h-1.51a.77.77 0 00-.76.77v6.38h-6.38a.77.77 0 00-.77.76V39a.78.78 0 00.77.77h7.91a1.52 1.52 0 001.53-1.53v-7.89a.78.78 0 00-.79-.77zM21.42 39v-1.51a.76.76 0 00-.76-.76h-6.38v-6.38a.78.78 0 00-.77-.77H12a.77.77 0 00-.76.77v7.91a1.52 1.52 0 001.53 1.53h7.91a.77.77 0 00.74-.79z"
  })))), p.showCloseButton && e.createElement(Ft, {
    buttonsBackgroundColor: p.backgroundColor,
    buttonsIconColor: p.iconColor,
    buttonsSize: p.size,
    buttonsIconPadding: p.iconPadding,
    title: "Close",
    className: "SRLCloseButton",
    onClick: function () {
      return C(this, n), o();
    }.bind(this)
  }, e.createElement("div", {
    className: "SRLCloseButton"
  }, e.createElement("svg", {
    className: "SRLCloseButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, e.createElement("path", {
    className: "SRLCloseButton",
    d: "M27.92 25l8.84-8.84 1.82-1.82c.27-.27.27-.71 0-.97l-1.95-1.95a.682.682 0 0 0-.97 0L25 22.08 14.34 11.42a.682.682 0 0 0-.97 0l-1.95 1.95c-.27.27-.27.71 0 .97L22.08 25 11.42 35.66c-.27.27-.27.71 0 .97l1.95 1.95c.27.27.71.27.97 0L25 27.92l8.84 8.84 1.82 1.82c.27.27.71.27.97 0l1.95-1.95c.27-.27.27-.71 0-.97L27.92 25z"
  }))))), p.showNextButton && e.createElement(Mt, {
    buttonsBackgroundColor: p.backgroundColor,
    buttonsIconColor: p.iconColor,
    buttonsSize: p.size,
    buttonsIconPadding: p.iconPadding,
    title: "Next",
    className: "SRLNextButton",
    onClick: function () {
      return C(this, n), r(d);
    }.bind(this)
  }, e.createElement("div", {
    className: "SRLNextButton"
  }, e.createElement("svg", {
    className: "SRLNextButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, e.createElement("path", {
    className: "SRLPrevButton",
    d: "M24.53 11.36l-.44.44c-.29.29-.29.76 0 1.05l11.09 11.09H11.83c-.41 0-.75.33-.75.75v.62c0 .41.33.75.75.75h23.35L24.09 37.14c-.29.29-.29.76 0 1.05l.44.44c.29.29.76.29 1.05 0l13.11-13.11c.29-.29.29-.76 0-1.05l-13.1-13.11a.754.754 0 0 0-1.06 0z"
  })))), p.showPrevButton && e.createElement(qt, {
    buttonsBackgroundColor: p.backgroundColor,
    buttonsIconColor: p.iconColor,
    buttonsSize: p.size,
    buttonsIconPadding: p.iconPadding,
    title: "Previous",
    className: "SRLPrevButton",
    onClick: function () {
      return C(this, n), i(d);
    }.bind(this)
  }, e.createElement("div", {
    className: "SRLPrevButton"
  }, e.createElement("svg", {
    className: "SRLPrevButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, e.createElement("path", {
    className: "SRLPrevButton",
    d: "M25.47 38.64l.44-.44c.29-.29.29-.76 0-1.05L14.82 26.06h23.35c.41 0 .75-.33.75-.75v-.62c0-.41-.33-.75-.75-.75H14.82l11.09-11.09c.29-.29.29-.76 0-1.05l-.44-.44a.742.742 0 0 0-1.05 0L11.31 24.47c-.29.29-.29.76 0 1.05l13.11 13.11c.29.3.76.3 1.05.01z"
  })))));
}.bind(void 0);
en.propTypes = {
  handleCloseLightbox: m.func,
  handleNextElement: m.func,
  handlePrevElement: m.func,
  handleFullScreen: m.func,
  handleImageDownload: m.func,
  handlePanzoom: m.func,
  panzoomEnabled: m.bool,
  setAutoplay: m.func,
  autoplay: m.bool,
  currentElementID: m.string,
  settings: m.shape({
    autoplaySpeed: m.number
  }),
  buttons: m.shape({
    backgroundColor: m.string,
    iconColor: m.string,
    iconPadding: m.string,
    showAutoplayButton: m.bool,
    showCloseButton: m.bool,
    showDownloadButton: m.bool,
    showFullscreenButton: m.bool,
    showNextButton: m.bool,
    showPrevButton: m.bool,
    size: m.string
  })
};
var tn = rn,
  nn = rn,
  on = function on(e, t, n) {
    e.removeEventListener("wheel", t, n);
  };
function rn(e, t, n) {
  e.addEventListener("wheel", t, n);
}
tn.addWheelListener = nn, tn.removeWheelListener = on;
var an = "function" == typeof Float32Array;
function sn(e, t) {
  return 1 - 3 * t + 3 * e;
}
function cn(e, t) {
  return 3 * t - 6 * e;
}
function ln(e) {
  return 3 * e;
}
function un(e, t, n) {
  return ((sn(t, n) * e + cn(t, n)) * e + ln(t)) * e;
}
function dn(e, t, n) {
  return 3 * sn(t, n) * e * e + 2 * cn(t, n) * e + ln(t);
}
function pn(e) {
  return e;
}
var hn = function hn(e, t, n, o) {
    if (!(0 <= e && e <= 1 && 0 <= n && n <= 1)) throw new Error("bezier x values must be in [0, 1] range");
    if (e === t && n === o) return pn;
    for (var r = an ? new Float32Array(11) : new Array(11), i = 0; i < 11; ++i) r[i] = un(.1 * i, e, n);
    function a(t) {
      for (var o = 0, i = 1; 10 !== i && r[i] <= t; ++i) o += .1;
      --i;
      var a = o + .1 * ((t - r[i]) / (r[i + 1] - r[i])),
        s = dn(a, e, n);
      return s >= .001 ? function (e, t, n, o) {
        for (var r = 0; r < 4; ++r) {
          var i = dn(t, n, o);
          if (0 === i) return t;
          t -= (un(t, n, o) - e) / i;
        }
        return t;
      }(t, a, e, n) : 0 === s ? a : function (e, t, n, o, r) {
        var i,
          a,
          s = 0;
        do {
          (i = un(a = t + (n - t) / 2, o, r) - e) > 0 ? n = a : t = a;
        } while (Math.abs(i) > 1e-7 && ++s < 10);
        return a;
      }(t, o, o + .1, e, n);
    }
    return function (e) {
      return 0 === e ? 0 : 1 === e ? 1 : un(a(e), t, o);
    };
  },
  fn = {
    ease: hn(.25, .1, .25, 1),
    easeIn: hn(.42, 0, 1, 1),
    easeOut: hn(0, 0, .58, 1),
    easeInOut: hn(.42, 0, .58, 1),
    linear: hn(0, 0, 1, 1)
  },
  mn = function mn(e, t, n) {
    var o = Object.create(null),
      r = Object.create(null),
      i = "function" == typeof (n = n || {}).easing ? n.easing : fn[n.easing];
    i || (n.easing && console.warn("Unknown easing function in amator: " + n.easing), i = fn.ease);
    var a = "function" == typeof n.step ? n.step : bn,
      s = "function" == typeof n.done ? n.done : bn,
      c = function (e) {
        if (!e) {
          return "undefined" != typeof window && window.requestAnimationFrame ? {
            next: window.requestAnimationFrame.bind(window),
            cancel: window.cancelAnimationFrame.bind(window)
          } : {
            next: function next(e) {
              return setTimeout(e, 1e3 / 60);
            },
            cancel: function cancel(e) {
              return clearTimeout(e);
            }
          };
        }
        if ("function" != typeof e.next) throw new Error("Scheduler is supposed to have next(cb) function");
        if ("function" != typeof e.cancel) throw new Error("Scheduler is supposed to have cancel(handle) function");
        return e;
      }(n.scheduler),
      l = Object.keys(t);
    l.forEach(function (n) {
      o[n] = e[n], r[n] = t[n] - e[n];
    });
    var u,
      d = "number" == typeof n.duration ? n.duration : 400,
      p = Math.max(1, .06 * d),
      h = 0;
    return u = c.next(function t() {
      var n = i(h / p);
      h += 1, function (t) {
        l.forEach(function (n) {
          e[n] = r[n] * t + o[n];
        });
      }(n), h <= p ? (u = c.next(t), a(e)) : (u = 0, setTimeout(function () {
        s(e);
      }, 0));
    }), {
      cancel: function cancel() {
        c.cancel(u), u = 0;
      }
    };
  },
  vn = yn,
  gn = yn();
function bn() {}
function yn() {
  var e = new Set(),
    t = new Set(),
    n = 0;
  return {
    next: o,
    cancel: o,
    clearAll: function clearAll() {
      e.clear(), t.clear(), cancelAnimationFrame(n), n = 0;
    }
  };
  function o(e) {
    t.add(e), n || (n = requestAnimationFrame(r));
  }
  function r() {
    n = 0;
    var o = t;
    t = e, (e = o).forEach(function (e) {
      e();
    }), e.clear();
  }
}
mn.makeAggregateRaf = vn, mn.sharedScheduler = gn;
var wn = function wn(e) {
  !function (e) {
    if (!e) throw new Error("Eventify cannot use falsy object as events subject");
    for (var t = ["on", "fire", "off"], n = 0; n < t.length; ++n) if (e.hasOwnProperty(t[n])) throw new Error("Subject cannot be eventified, since it already has property '" + t[n] + "'");
  }(e);
  var t = function (e) {
    var t = Object.create(null);
    return {
      on: function on(n, o, r) {
        if ("function" != typeof o) throw new Error("callback is expected to be a function");
        var i = t[n];
        return i || (i = t[n] = []), i.push({
          callback: o,
          ctx: r
        }), e;
      },
      off: function off(n, o) {
        if (void 0 === n) return t = Object.create(null), e;
        if (t[n]) if ("function" != typeof o) delete t[n];else for (var r = t[n], i = 0; i < r.length; ++i) r[i].callback === o && r.splice(i, 1);
        return e;
      },
      fire: function fire(n) {
        var o,
          r = t[n];
        if (!r) return e;
        arguments.length > 1 && (o = Array.prototype.splice.call(arguments, 1));
        for (var i = 0; i < r.length; ++i) {
          var a = r[i];
          a.callback.apply(a.ctx, o);
        }
        return e;
      }
    };
  }(e);
  return e.on = t.on, e.off = t.off, e.fire = t.fire, e;
};
var xn = function xn(e, t, n) {
  "object" != typeof n && (n = {});
  var o,
    r,
    i,
    a,
    s,
    c,
    l,
    u,
    d,
    p,
    h = "number" == typeof n.minVelocity ? n.minVelocity : 5,
    f = "number" == typeof n.amplitude ? n.amplitude : .25,
    m = "function" == typeof n.cancelAnimationFrame ? n.cancelAnimationFrame : "function" == typeof _.cancelAnimationFrame ? _.cancelAnimationFrame : clearTimeout,
    v = "function" == typeof n.requestAnimationFrame ? n.requestAnimationFrame : "function" == typeof _.requestAnimationFrame ? _.requestAnimationFrame : function (e) {
      return setTimeout(e, 16);
    };
  return {
    start: function start() {
      o = e(), c = d = a = l = 0, r = new Date(), m(i), m(p), i = v(g);
    },
    stop: function stop() {
      m(i), m(p);
      var t = e();
      s = t.x, u = t.y, r = Date.now(), (a < -h || a > h) && (s += c = f * a);
      (l < -h || l > h) && (u += d = f * l);
      p = v(b);
    },
    cancel: function cancel() {
      m(i), m(p);
    }
  };
  function g() {
    var t = Date.now(),
      n = t - r;
    r = t;
    var s = e(),
      c = s.x - o.x,
      u = s.y - o.y;
    o = s;
    var d = 1e3 / (1 + n);
    a = .8 * c * d + .2 * a, l = .8 * u * d + .2 * l, i = v(g);
  }
  function b() {
    var e = Date.now() - r,
      n = !1,
      o = 0,
      i = 0;
    c && ((o = -c * Math.exp(-e / 342)) > .5 || o < -.5 ? n = !0 : o = c = 0), d && ((i = -d * Math.exp(-e / 342)) > .5 || i < -.5 ? n = !0 : i = d = 0), n && (t(s + o, u + i), p = v(b));
  }
};
var En = function En(e) {
  if (e) return {
    capture: Cn,
    release: Cn
  };
  var t,
    n,
    o,
    r = !1;
  return {
    capture: function capture(e) {
      r = !0, n = window.document.onselectstart, o = window.document.ondragstart, window.document.onselectstart = Sn, (t = e).ondragstart = Sn;
    },
    release: function release() {
      if (!r) return;
      r = !1, window.document.onselectstart = n, t && (t.ondragstart = o);
    }
  };
};
function Sn(e) {
  return e.stopPropagation(), !1;
}
function Cn() {}
var kn = function kn() {
  this.x = 0, this.y = 0, this.scale = 1;
};
var Ln = function Ln(e, t) {
    if (!On(e)) throw new Error("svg element is required for svg.panzoom to work");
    var n = e.ownerSVGElement;
    if (!n) throw new Error("Do not apply panzoom to the root <svg> element. Use its child instead (e.g. <g></g>). As of March 2016 only FireFox supported transform on the root element");
    t.disableKeyboardInteraction || n.setAttribute("tabindex", 0);
    return {
      getBBox: function getBBox() {
        var t = e.getBBox();
        return {
          left: t.x,
          top: t.y,
          width: t.width,
          height: t.height
        };
      },
      getScreenCTM: function getScreenCTM() {
        var e = n.getCTM();
        if (!e) return n.getScreenCTM();
        return e;
      },
      getOwner: function getOwner() {
        return n;
      },
      applyTransform: function applyTransform(t) {
        e.setAttribute("transform", "matrix(" + t.scale + " 0 0 " + t.scale + " " + t.x + " " + t.y + ")");
      },
      initTransform: function initTransform(t) {
        var o = e.getCTM();
        t.x = o.e, t.y = o.f, t.scale = o.a, n.removeAttributeNS(null, "viewBox");
      }
    };
  },
  Tn = On;
function On(e) {
  return e && e.ownerSVGElement && e.getCTM;
}
Ln.canAttach = Tn;
var Nn = function Nn(e, t) {
    if (!_n(e)) throw new Error("panzoom requires DOM element to be attached to the DOM tree");
    var n = e.parentElement;
    e.scrollTop = 0, t.disableKeyboardInteraction || n.setAttribute("tabindex", 0);
    return {
      getBBox: function getBBox() {
        return {
          left: 0,
          top: 0,
          width: e.clientWidth,
          height: e.clientHeight
        };
      },
      getOwner: function getOwner() {
        return n;
      },
      applyTransform: function applyTransform(t) {
        e.style.transformOrigin = "0 0 0", e.style.transform = "matrix(" + t.scale + ", 0, 0, " + t.scale + ", " + t.x + ", " + t.y + ")";
      }
    };
  },
  An = _n;
function _n(e) {
  return e && e.parentElement && e.style;
}
Nn.canAttach = An;
var Pn = En(),
  Rn = En(!0),
  zn = Fn;
function Fn(e, t) {
  var n = (t = t || {}).controller;
  if (n || (Ln.canAttach(e) ? n = Ln(e, t) : Nn.canAttach(e) && (n = Nn(e, t))), !n) throw new Error("Cannot create panzoom for the current type of dom element");
  var o = n.getOwner(),
    r = {
      x: 0,
      y: 0
    },
    i = !1,
    a = new kn();
  n.initTransform && n.initTransform(a);
  var s,
    c = "function" == typeof t.filterKey ? t.filterKey : Dn,
    l = "number" == typeof t.pinchSpeed ? t.pinchSpeed : 1,
    u = t.bounds,
    d = "number" == typeof t.maxZoom ? t.maxZoom : Number.POSITIVE_INFINITY,
    p = "number" == typeof t.minZoom ? t.minZoom : 0,
    h = "number" == typeof t.boundsPadding ? t.boundsPadding : .05,
    f = "number" == typeof t.zoomDoubleClickSpeed ? t.zoomDoubleClickSpeed : 1.75,
    m = t.beforeWheel || Dn,
    v = t.beforeMouseDown || Dn,
    g = "number" == typeof t.zoomSpeed ? t.zoomSpeed : 1,
    b = In(t.transformOrigin),
    y = t.enableTextSelection ? Rn : Pn;
  !function (e) {
    var t = typeof e;
    if ("undefined" === t || "boolean" === t) return;
    if (!(jn(e.left) && jn(e.top) && jn(e.bottom) && jn(e.right))) throw new Error("Bounds object is not valid. It can be: undefined, boolean (true|false) or an object {left, top, right, bottom}");
  }(u), t.autocenter && function () {
    var e,
      t,
      r = 0,
      i = 0,
      s = B();
    if (s) r = s.left, i = s.top, e = s.right - s.left, t = s.bottom - s.top;else {
      var c = o.getBoundingClientRect();
      e = c.width, t = c.height;
    }
    var l = n.getBBox();
    if (0 === l.width || 0 === l.height) return;
    var u = t / l.height,
      d = e / l.width,
      p = Math.min(d, u);
    a.x = -(l.left + l.width / 2) * p + e / 2 + r, a.y = -(l.top + l.height / 2) * p + t / 2 + i, a.scale = p;
  }();
  var w,
    x,
    E,
    S,
    C,
    k,
    L,
    T,
    O = 0,
    N = !1,
    A = !1;
  C = "smoothScroll" in t && !t.smoothScroll ? {
    start: Dn,
    stop: Dn,
    cancel: Dn
  } : xn(function () {
    return {
      x: a.x,
      y: a.y
    };
  }, function (e, t) {
    ce(), z(e, t);
  }, t.smoothScroll);
  var _ = !1;
  V();
  var P = {
    dispose: function dispose() {
      W();
    },
    moveBy: q,
    moveTo: z,
    centerOn: function centerOn(e) {
      var t = e.ownerSVGElement;
      if (!t) throw new Error("ui element is required to be within the scene");
      var n = e.getBoundingClientRect(),
        o = n.left + n.width / 2,
        r = n.top + n.height / 2,
        i = t.getBoundingClientRect(),
        a = i.width / 2 - o,
        s = i.height / 2 - r;
      q(a, s, !0);
    },
    zoomTo: se,
    zoomAbs: M,
    smoothZoom: ie,
    smoothZoomAbs: function smoothZoomAbs(e, t, n) {
      var o = {
          scale: a.scale
        },
        r = {
          scale: n
        };
      C.cancel(), ce(), L = mn(o, r, {
        step: function step(n) {
          M(e, t, n.scale);
        }
      });
    },
    showRectangle: function showRectangle(e) {
      var t = o.getBoundingClientRect(),
        n = R(t.width, t.height),
        r = e.right - e.left,
        i = e.bottom - e.top;
      if (!Number.isFinite(r) || !Number.isFinite(i)) throw new Error("Invalid rectangle");
      var s = n.x / r,
        c = n.y / i,
        l = Math.min(s, c);
      a.x = -(e.left + r / 2) * l + n.x / 2, a.y = -(e.top + i / 2) * l + n.y / 2, a.scale = l;
    },
    pause: function pause() {
      W(), _ = !0;
    },
    resume: function resume() {
      _ && (V(), _ = !1);
    },
    isPaused: function isPaused() {
      return _;
    },
    getTransform: function getTransform() {
      return a;
    },
    getMinZoom: function getMinZoom() {
      return p;
    },
    setMinZoom: function setMinZoom(e) {
      p = e;
    },
    getMaxZoom: function getMaxZoom() {
      return d;
    },
    setMaxZoom: function setMaxZoom(e) {
      d = e;
    },
    getTransformOrigin: function getTransformOrigin() {
      return b;
    },
    setTransformOrigin: function setTransformOrigin(e) {
      b = In(e);
    },
    getZoomSpeed: function getZoomSpeed() {
      return g;
    },
    setZoomSpeed: function setZoomSpeed(e) {
      if (!Number.isFinite(e)) throw new Error("Zoom speed should be a number");
      g = e;
    }
  };
  return wn(P), P;
  function R(e, t) {
    if (n.getScreenCTM) {
      var o = n.getScreenCTM(),
        i = o.a,
        a = o.d,
        s = o.e,
        c = o.f;
      r.x = e * i - s, r.y = t * a - c;
    } else r.x = e, r.y = t;
    return r;
  }
  function z(e, t) {
    a.x = e, a.y = t, I(), he("pan"), D();
  }
  function F(e, t) {
    z(a.x + e, a.y + t);
  }
  function I() {
    var e = B();
    if (e) {
      var t,
        o,
        r,
        i,
        s = !1,
        c = (t = n.getBBox(), r = t.left, i = t.top, {
          left: (o = {
            x: r * a.scale + a.x,
            y: i * a.scale + a.y
          }).x,
          top: o.y,
          right: t.width * a.scale + o.x,
          bottom: t.height * a.scale + o.y
        }),
        l = e.left - c.right;
      return l > 0 && (a.x += l, s = !0), (l = e.right - c.left) < 0 && (a.x += l, s = !0), (l = e.top - c.bottom) > 0 && (a.y += l, s = !0), (l = e.bottom - c.top) < 0 && (a.y += l, s = !0), s;
    }
  }
  function B() {
    if (u) {
      if ("boolean" == typeof u) {
        var e = o.getBoundingClientRect(),
          t = e.width,
          n = e.height;
        return {
          left: t * h,
          top: n * h,
          right: t * (1 - h),
          bottom: n * (1 - h)
        };
      }
      return u;
    }
  }
  function D() {
    i = !0, s = window.requestAnimationFrame(U);
  }
  function j(e, t, n) {
    if (Mn(e) || Mn(t) || Mn(n)) throw new Error("zoom requires valid numbers");
    var o = a.scale * n;
    if (o < p) {
      if (a.scale === p) return;
      n = p / a.scale;
    }
    if (o > d) {
      if (a.scale === d) return;
      n = d / a.scale;
    }
    var r = R(e, t);
    (a.x = r.x - n * (r.x - a.x), a.y = r.y - n * (r.y - a.y), u && 1 === h && 1 === p) ? (a.scale *= n, I()) : I() || (a.scale *= n);
    he("zoom"), D();
  }
  function M(e, t, n) {
    j(e, t, n / a.scale);
  }
  function q(e, t, n) {
    if (!n) return F(e, t);
    k && k.cancel();
    var o = 0,
      r = 0;
    k = mn({
      x: 0,
      y: 0
    }, {
      x: e,
      y: t
    }, {
      step: function step(e) {
        F(e.x - o, e.y - r), o = e.x, r = e.y;
      }
    });
  }
  function V() {
    o.addEventListener("mousedown", J, {
      passive: !1
    }), o.addEventListener("dblclick", K, {
      passive: !1
    }), o.addEventListener("touchstart", H, {
      passive: !1
    }), o.addEventListener("keydown", Y, {
      passive: !1
    }), tn.addWheelListener(o, oe, {
      passive: !1
    }), D();
  }
  function W() {
    tn.removeWheelListener(o, oe), o.removeEventListener("mousedown", J), o.removeEventListener("keydown", Y), o.removeEventListener("dblclick", K), o.removeEventListener("touchstart", H), s && (window.cancelAnimationFrame(s), s = 0), C.cancel(), te(), ne(), y.release(), de();
  }
  function U() {
    i && (i = !1, n.applyTransform(a), he("transform"), s = 0);
  }
  function Y(e) {
    var t = 0,
      n = 0,
      r = 0;
    if (38 === e.keyCode ? n = 1 : 40 === e.keyCode ? n = -1 : 37 === e.keyCode ? t = 1 : 39 === e.keyCode ? t = -1 : 189 === e.keyCode || 109 === e.keyCode ? r = 1 : 187 !== e.keyCode && 107 !== e.keyCode || (r = -1), !c(e, t, n, r)) {
      if (t || n) {
        e.preventDefault(), e.stopPropagation();
        var i = o.getBoundingClientRect();
        q(.05 * (a = Math.min(i.width, i.height)) * t, .05 * a * n);
      }
      if (r) {
        var a,
          s = le(100 * r);
        se((a = b ? ae() : {
          x: (l = o.getBoundingClientRect()).width / 2,
          y: l.height / 2
        }).x, a.y, s);
      }
      var l;
    }
  }
  function H(e) {
    if (function (e) {
      if (t.onTouch && !t.onTouch(e)) return;
      e.stopPropagation(), e.preventDefault();
    }(e), 1 === e.touches.length) return function (e) {
      var t = re(e.touches[0]);
      w = t;
      var n = R(t.x, t.y);
      x = n.x, E = n.y, C.cancel(), G();
    }(e, e.touches[0]);
    2 === e.touches.length && (S = X(e.touches[0], e.touches[1]), T = !0, G());
  }
  function G() {
    N || (N = !0, document.addEventListener("touchmove", $), document.addEventListener("touchend", Z), document.addEventListener("touchcancel", Z));
  }
  function $(e) {
    if (1 === e.touches.length) {
      e.stopPropagation();
      var t = R((d = re(e.touches[0])).x, d.y),
        n = t.x - x,
        o = t.y - E;
      0 !== n && 0 !== o && ue(), x = t.x, E = t.y, q(n, o);
    } else if (2 === e.touches.length) {
      T = !0;
      var r = e.touches[0],
        i = e.touches[1],
        a = X(r, i),
        s = 1 + (a / S - 1) * l,
        c = re(r),
        u = re(i);
      if (x = (c.x + u.x) / 2, E = (c.y + u.y) / 2, b) {
        var d = ae();
        x = d.x, E = d.y;
      }
      se(x, E, s), S = a, e.stopPropagation(), e.preventDefault();
    }
  }
  function Z(e) {
    if (e.touches.length > 0) {
      var t = R((n = re(e.touches[0])).x, n.y);
      x = t.x, E = t.y;
    } else {
      var n,
        o = new Date();
      if (o - O < 300) if (b) ie((n = ae()).x, n.y, f);else ie(w.x, w.y, f);
      O = o, de(), ne();
    }
  }
  function X(e, t) {
    var n = e.clientX - t.clientX,
      o = e.clientY - t.clientY;
    return Math.sqrt(n * n + o * o);
  }
  function K(e) {
    !function (e) {
      t.onDoubleClick && !t.onDoubleClick(e) || (e.preventDefault(), e.stopPropagation());
    }(e);
    var n = re(e);
    b && (n = ae()), ie(n.x, n.y, f);
  }
  function J(e) {
    if (!v(e)) {
      if (N) return e.stopPropagation(), !1;
      if (1 === e.button && null !== window.event || 0 === e.button) {
        C.cancel();
        var t = re(e),
          n = R(t.x, t.y);
        return x = n.x, E = n.y, document.addEventListener("mousemove", Q), document.addEventListener("mouseup", ee), y.capture(e.target || e.srcElement), !1;
      }
    }
  }
  function Q(e) {
    if (!N) {
      ue();
      var t = re(e),
        n = R(t.x, t.y),
        o = n.x - x,
        r = n.y - E;
      x = n.x, E = n.y, q(o, r);
    }
  }
  function ee() {
    y.release(), de(), te();
  }
  function te() {
    document.removeEventListener("mousemove", Q), document.removeEventListener("mouseup", ee), A = !1;
  }
  function ne() {
    document.removeEventListener("touchmove", $), document.removeEventListener("touchend", Z), document.removeEventListener("touchcancel", Z), A = !1, T = !1, N = !1;
  }
  function oe(e) {
    if (!m(e)) {
      C.cancel();
      var t = e.deltaY;
      e.deltaMode > 0 && (t *= 100);
      var n = le(t);
      if (1 !== n) {
        var o = b ? ae() : re(e);
        se(o.x, o.y, n), e.preventDefault();
      }
    }
  }
  function re(e) {
    var t = o.getBoundingClientRect();
    return {
      x: e.clientX - t.left,
      y: e.clientY - t.top
    };
  }
  function ie(e, t, n) {
    var o = a.scale,
      r = {
        scale: o
      },
      i = {
        scale: n * o
      };
    C.cancel(), ce(), L = mn(r, i, {
      step: function step(n) {
        M(e, t, n.scale);
      },
      done: pe
    });
  }
  function ae() {
    var e = o.getBoundingClientRect();
    return {
      x: e.width * b.x,
      y: e.height * b.y
    };
  }
  function se(e, t, n) {
    return C.cancel(), ce(), j(e, t, n);
  }
  function ce() {
    L && (L.cancel(), L = null);
  }
  function le(e) {
    return 1 - Math.sign(e) * Math.min(.25, Math.abs(g * e / 128));
  }
  function ue() {
    A || (he("panstart"), A = !0, C.start());
  }
  function de() {
    A && (T || C.stop(), he("panend"));
  }
  function pe() {
    he("zoomend");
  }
  function he(e) {
    P.fire(e, P);
  }
}
function In(e) {
  if (e) return "object" == typeof e ? (jn(e.x) && jn(e.y) || Bn(e), e) : void Bn();
}
function Bn(e) {
  throw console.error(e), new Error(["Cannot parse transform origin.", "Some good examples:", '  "center center" can be achieved with {x: 0.5, y: 0.5}', '  "top center" can be achieved with {x: 0.5, y: 0}', '  "bottom right" can be achieved with {x: 1, y: 1}'].join("\n"));
}
function Dn() {}
function jn(e) {
  return Number.isFinite(e);
}
function Mn(e) {
  return Number.isNaN ? Number.isNaN(e) : e != e;
}
!function () {
  if ("undefined" != typeof document) {
    var e = document.getElementsByTagName("script");
    if (e) {
      for (var t, n = 0; n < e.length; ++n) {
        var o = e[n];
        if (o.src && o.src.match(/\bpanzoom(\.min)?\.js/)) {
          t = o;
          break;
        }
      }
      if (t) {
        var r = t.getAttribute("query");
        if (r) {
          var i = t.getAttribute("name") || "pz",
            a = Date.now();
          !function e() {
            var n = document.querySelector(r);
            if (!n) {
              return Date.now() - a < 2e3 ? void setTimeout(e, 100) : void console.error("Cannot find the panzoom element", i);
            }
            var o = function (e) {
              for (var t = e.attributes, n = {}, o = 0; o < t.length; ++o) {
                var r = s(t[o]);
                r && (n[r.name] = r.value);
              }
              return n;
            }(t);
            console.log(o), window[i] = Fn(n, o);
          }();
        }
      }
    }
  }
  function s(e) {
    if (e.name && "p" === e.name[0] && "z" === e.name[1] && "-" === e.name[2]) return {
      name: e.name.substr(3),
      value: JSON.parse(e.value)
    };
  }
}();
var qn,
  Vn = P(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = {
        fullscreenEnabled: 0,
        fullscreenElement: 1,
        requestFullscreen: 2,
        exitFullscreen: 3,
        fullscreenchange: 4,
        fullscreenerror: 5
      },
      o = ["webkitFullscreenEnabled", "webkitFullscreenElement", "webkitRequestFullscreen", "webkitExitFullscreen", "webkitfullscreenchange", "webkitfullscreenerror"],
      r = ["mozFullScreenEnabled", "mozFullScreenElement", "mozRequestFullScreen", "mozCancelFullScreen", "mozfullscreenchange", "mozfullscreenerror"],
      i = ["msFullscreenEnabled", "msFullscreenElement", "msRequestFullscreen", "msExitFullscreen", "MSFullscreenChange", "MSFullscreenError"],
      a = "undefined" != typeof window && void 0 !== window.document ? window.document : {},
      s = "fullscreenEnabled" in a && Object.keys(n) || o[0] in a && o || r[0] in a && r || i[0] in a && i || [];
    t.default = {
      requestFullscreen: function requestFullscreen(e) {
        return e[s[n.requestFullscreen]]();
      },
      requestFullscreenFunction: function requestFullscreenFunction(e) {
        return e[s[n.requestFullscreen]];
      },
      get exitFullscreen() {
        return a[s[n.exitFullscreen]].bind(a);
      },
      addEventListener: function addEventListener(e, t, o) {
        return a.addEventListener(s[n[e]], t, o);
      },
      removeEventListener: function removeEventListener(e, t, o) {
        return a.removeEventListener(s[n[e]], t, o);
      },
      get fullscreenEnabled() {
        return Boolean(a[s[n.fullscreenEnabled]]);
      },
      set fullscreenEnabled(e) {},
      get fullscreenElement() {
        return a[s[n.fullscreenElement]];
      },
      set fullscreenElement(e) {},
      get onfullscreenchange() {
        return a[("on" + s[n.fullscreenchange]).toLowerCase()];
      },
      set onfullscreenchange(e) {
        return a[("on" + s[n.fullscreenchange]).toLowerCase()] = e;
      },
      get onfullscreenerror() {
        return a[("on" + s[n.fullscreenerror]).toLowerCase()];
      },
      set onfullscreenerror(e) {
        return a[("on" + s[n.fullscreenerror]).toLowerCase()] = e;
      }
    };
  }),
  Wn = (qn = Vn) && qn.__esModule && Object.prototype.hasOwnProperty.call(qn, "default") ? qn.default : qn,
  Un = function Un(e) {
    for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
    return e.addEventListener.apply(e, t);
  },
  Yn = function Yn(e) {
    for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
    return e.removeEventListener.apply(e, t);
  };
require("fast-deep-equal/react");
var Hn = ["mousemove", "mousedown", "resize", "keydown", "touchstart", "wheel"],
  Gn = function Gn(e, t, n) {
    void 0 === e && (e = 6e4), void 0 === t && (t = !1), void 0 === n && (n = Hn);
    var o = r(t),
      a = o[0],
      s = o[1];
    return i(function () {
      for (var t, o = !0, r = a, i = function i(e) {
          o && (r = e, s(e));
        }, c = function (e, t, n, o) {
          var r,
            i = !1,
            a = 0;
          function s() {
            r && clearTimeout(r);
          }
          function c() {
            var c = this,
              l = Date.now() - a,
              u = arguments;
            function d() {
              a = Date.now(), n.apply(c, u);
            }
            function p() {
              r = void 0;
            }
            i || (o && !r && d(), s(), void 0 === o && l > e ? d() : !0 !== t && (r = setTimeout(o ? p : d, void 0 === o ? e - l : e)));
          }
          return "boolean" != typeof t && (o = n, n = t, t = void 0), c.cancel = function () {
            s(), i = !0;
          }, c;
        }(50, function () {
          r && i(!1), clearTimeout(t), t = setTimeout(function () {
            return i(!0);
          }, e);
        }), l = function l() {
          document.hidden || c();
        }, u = 0; u < n.length; u++) Un(window, n[u], c);
      return Un(document, "visibilitychange", l), t = setTimeout(function () {
        return i(!0);
      }, e), function () {
        o = !1;
        for (var e = 0; e < n.length; e++) Yn(window, n[e], c);
        Yn(document, "visibilitychange", l);
      };
    }, [e, n]), a;
  },
  $n = require("lodash/findIndex"),
  Zn = function (t) {
    var a = this;
    C(this, void 0);
    var s = t.options,
      c = t.callbacks,
      l = t.selectedElement,
      u = t.elements,
      d = t.dispatch,
      p = n(N),
      h = o(),
      m = o(),
      v = o(),
      b = s.buttons,
      w = s.settings,
      E = c.onCountSlides,
      k = c.onSlideChange,
      T = c.onLightboxClosed,
      O = c.onLightboxOpened,
      A = f(function (e) {
        if (C(this, a), "function" == typeof k) return p.callbacks.onSlideChange(e);
        console.error('Simple React Lightbox error: you are not passing a function in your "onSlideChange" callback! You are passing a '.concat(g(k), "."));
      }.bind(this), [p.callbacks, k]),
      _ = f(function (e) {
        C(this, a), "function" == typeof O ? p.callbacks.onLightboxOpened(e) : console.error('Simple React Lightbox error: you are not passing a function in your "onLightboxOpened" callback! You are passing a '.concat(g(O), "."));
      }.bind(this), [p.callbacks, O]),
      P = f(function (e) {
        C(this, a), "function" == typeof T ? p.callbacks.onLightboxClosed(e) : console.error('Simple React Lightbox error: you are not passing a function in your "onLightboxClosed" callback! You are passing a '.concat(g(T), "."));
      }.bind(this), [p.callbacks, T]),
      R = f(function (e) {
        C(this, a), "function" == typeof E ? p.callbacks.onCountSlides(e) : console.error('Simple React Lightbox error: you are not passing a function in your "onCountSlides" callback! You are passing a '.concat(g(E), "."));
      }.bind(this), [p.callbacks, E]),
      z = L(r(l), 2),
      F = z[0],
      I = z[1],
      B = L(r(!1), 2),
      D = B[0],
      j = B[1],
      M = L(r(!1), 2),
      q = M[0],
      V = M[1],
      W = Gn(w.hideControlsAfter < 1e3 ? 9999999 : w.hideControlsAfter),
      U = f(function (e) {
        return C(this, a), $n(u, function (t) {
          return t.id === e;
        });
      }.bind(this), [u]),
      Y = f(function (e) {
        C(this, a), w.disablePanzoom || V(e);
      }.bind(this), [w.disablePanzoom]);
    function H(e) {
      var t = this;
      return fetch(e).then(function (e) {
        return C(this, t), e.blob();
      }.bind(this)).then(function (e) {
        return C(this, t), URL.createObjectURL(e);
      }.bind(this));
    }
    function G() {
      return (G = y(_regeneratorRuntime.mark(function e() {
        var t;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = document.createElement("a"), e.next = 3, H(F.source);
            case 3:
              t.href = e.sent, t.download = "", document.body.appendChild(t), t.click(), document.body.removeChild(t);
            case 8:
            case "end":
              return e.stop();
          }
        }, e);
      }))).apply(this, arguments);
    }
    var $ = f(function (e) {
        C(this, a), Y(!1);
        var t = U(e),
          n = u[t];
        I({
          source: n.source,
          caption: n.caption,
          id: n.id,
          width: n.width,
          height: n.height
        }), A({
          action: "selected",
          slides: {
            previous: u[t - 1],
            current: n,
            next: u[t + 1]
          },
          index: t
        });
      }.bind(this), [u, U, Y, A]),
      Z = f(function (e) {
        C(this, a), Y(!1);
        var t = U(e),
          n = u[t - 1] || u[u.length - 1];
        I(S({}, n));
        var o = t - 1 == -1 ? u.length - 1 : t - 1;
        A({
          action: "left",
          slides: {
            previous: u[o - 1],
            current: n,
            next: u[o + 1]
          },
          index: o
        });
      }.bind(this), [u, U, Y, A]),
      X = f(function (e) {
        C(this, a), Y(!1);
        var t = U(e),
          n = u[t + 1] || u[0];
        I(S({}, n));
        var o = t + 1 === u.length ? 0 : t + 1;
        A({
          action: "right",
          slides: {
            previous: u[o - 1],
            current: n,
            next: u[o + 1]
          },
          index: o
        });
      }.bind(this), [u, U, Y, A]),
      K = f(function () {
        C(this, a), d({
          type: "CLOSE_LIGHTBOX"
        }), P({
          opened: !1,
          currentSlide: p.selectedElement
        });
      }.bind(this), [d, P, p.selectedElement]);
    !function (e, t) {
      var n = this,
        r = o();
      i(function () {
        C(this, n), r.current = e;
      }.bind(this), [e]), i(function () {
        var e = this;
        if (C(this, n), null !== t) {
          var o = setInterval(function () {
            r.current();
          }, t);
          return function () {
            return C(this, e), clearInterval(o);
          }.bind(this);
        }
      }.bind(this), [t]);
    }(function () {
      return C(this, a), X(F.id);
    }.bind(this), D ? w.autoplaySpeed : null);
    var J = f(function (e) {
      C(this, a), "ArrowRight" !== e.key && "ArrowUp" !== e.key || X(F.id), "ArrowLeft" !== e.key && "ArrowDown" !== e.key || Z(F.id), "Escape" === e.key && K();
    }.bind(this), [X, Z, K, F.id]);
    i(function () {
      C(this, a), _({
        opened: !0,
        currentSlide: p.selectedElement
      }), R({
        totalSlide: p.elements.length
      });
    }.bind(this), []), i(function () {
      if (C(this, a), 0 === w.hideControlsAfter && w.hideControlsAfter || (W ? null !== v.current && void 0 !== v.current && v.current.classList.add("SRLIdle") : null !== v.current && void 0 !== v.current && v.current.classList.contains("SRLIdle") && v.current.classList.remove("SRLIdle")), !w.disablePanzoom && q) {
        var e = m.current,
          t = zn(e, {
            bounds: !0,
            maxZoom: 3,
            minZoom: .9
          });
        void 0 === e && null === e || (t.zoomAbs(0, 0, 1.5), t.moveTo(0, 0));
      }
      return void 0 === F.id && I({
        source: u[0].source,
        caption: u[0].caption,
        id: u[0].id,
        width: u[0].width,
        height: u[0].height
      }), w.disableKeyboardControls || document.addEventListener("keydown", J, !1), "undefined" != typeof window && (document.body.classList.add("SRLOpened"), document.body.style.overflow = "hidden"), function () {
        "undefined" != typeof window && (document.body.classList.remove("SRLOpened"), document.body.style.overflow = null), document.removeEventListener("keydown", J, !1);
      };
    }.bind(this), [p.callbacks, F.id, u, w.disablePanzoom, w.disableKeyboardControls, q, w.hideControlsAfter, W, J]);
    var Q = {
        currentElementID: F.id,
        handleCurrentElement: $,
        handleNextElement: X,
        handlePrevElement: Z,
        handleCloseLightbox: K,
        handleFullScreen: function handleFullScreen() {
          var e = "";
          "undefined" != typeof window && (e = document.querySelector(".SRLImage") || document.querySelector(".SRLPanzoomImage")), null !== e && Wn.fullscreenEnabled && (Wn.addEventListener("fullscreenchange", null, !1), Wn.requestFullscreen(e));
        },
        handleImageDownload: function handleImageDownload() {
          return G.apply(this, arguments);
        },
        handlePanzoom: Y,
        autoplay: D,
        panzoomEnabled: q,
        settings: w,
        buttons: b,
        setAutoplay: j,
        SRLLightboxImageRef: h,
        SRLLightboxPanzoomImageRef: m
      },
      ee = {
        buttonsBackgroundColor: s.buttons.backgroundColor,
        buttonsIconColor: s.buttons.iconColor,
        buttonsSize: s.buttons.size,
        buttonsIconPadding: s.buttons.iconPadding
      };
    return e.createElement(Lt, {
      ref: v,
      overlayColor: s.settings.overlayColor,
      className: "SRLStage"
    }, e.createElement(en, x({}, ee, Q)), e.createElement(Qt, x({}, F, Q, {
      elements: u,
      options: s
    })));
  }.bind(void 0);
Zn.propTypes = {
  callbacks: m.object,
  elements: m.array,
  isOpened: m.bool,
  dispatch: m.func,
  selectedElement: m.object,
  options: m.shape({
    settings: m.shape({
      overlayColor: m.string,
      autoplaySpeed: m.number,
      disableKeyboardControls: m.bool,
      disablePanzoom: m.bool,
      hideControlsAfter: m.oneOfType([m.number, m.bool])
    }),
    buttons: m.shape({
      backgroundColor: m.string,
      iconColor: m.string,
      iconPadding: m.string,
      size: m.string
    })
  })
};
function Xn() {
  var e = k(["\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n\n  &.portal-transition-enter {\n    opacity: 0;\n  }\n  &.portal-transition-enter-active {\n    opacity: 1;\n    transition: opacity ", "ms\n      ", ";\n  }\n  &.portal-transition-exit {\n    opacity: 1;\n  }\n  &.portal-transition-exit-active {\n    opacity: 0;\n    transition: opacity ", "ms\n      ", ";\n  }\n"]);
  return Xn = function Xn() {
    return e;
  }, e;
}
var Kn = at(oe)(Xn(), function (e) {
  return C(this, void 0), e.lightboxTransitionSpeed;
}.bind(void 0), function (e) {
  return C(this, void 0), e.lightboxTransitionTimingFunction;
}.bind(void 0), function (e) {
  return C(this, void 0), e.lightboxTransitionSpeed;
}.bind(void 0), function (e) {
  return C(this, void 0), e.lightboxTransitionTimingFunction;
}.bind(void 0));
function Jn() {
  var t = n(N),
    o = t.options,
    r = t.isOpened;
  return e.createElement(X, {
    in: r,
    classNames: "portal-transition",
    timeout: o.settings.lightboxTransitionSpeed
  }, e.createElement(Kn, {
    selector: "SRLLightbox",
    isOpened: r,
    lightboxTransitionSpeed: o.settings.lightboxTransitionSpeed,
    lightboxTransitionTimingFunction: o.settings.lightboxTransitionTimingFunction
  }, e.createElement(Zn, t)));
}
function Qn() {
  var e = this,
    t = n(N);
  return {
    openLightbox: function (n) {
      C(this, e), t.dispatch({
        type: "OPEN_AT_INDEX",
        index: n
      });
    }.bind(this),
    closeLightbox: function () {
      C(this, e), t.dispatch({
        type: "CLOSE_LIGHTBOX"
      });
    }.bind(this)
  };
}
Jn.propTypes = {
  context: m.object
};
var eo = function (t) {
  C(this, void 0);
  var n = t.children;
  return e.createElement(A, null, n, e.createElement(Jn, null));
}.bind(void 0);
eo.propTypes = {
  children: m.oneOfType([m.arrayOf(m.node), m.node]).isRequired
};
export default eo;
export { B as SRLWrapper, Qn as useLightbox };